webpackJsonp([1],{

/***/ "6ztS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Fv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "89bq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bb3O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bhpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KV5D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b688dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("fNxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd1f1a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("KV5D")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ce7210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("JFPs")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-69ce7210"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5864a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("Du5H")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-7ba5864a"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eed32ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}),0)]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("89bq")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9eed32ec"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94907be2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("QRRU")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad378a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}),0)])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Zhdp")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2470dd02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}),0)])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("Bhpb")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f0bddd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("f34v")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8e3a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("mp9z")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfd056f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("gUQz")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5aec612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){return _vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()}),0):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("clAw")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e57029e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1)])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("6ztS")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39079333","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){return _vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])}),0),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("be29")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c984c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205d0721","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}),0)}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("UR7i")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3e62da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("m1X4")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fd9192","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}),0)],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("WI9Y")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-26fd9192"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ee35ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("7Fv8")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6de9100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("gkoj")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f4afce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Bb3O")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "UEFA Direct Nr. 192",
  "shortTitle": "",
  "description": "",
  "width": 690,
  "height": 900,
  "currentLanguage": "DE",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://uefadirect.uefa.com/192/en"
  }, {
    code: "FR",
    text: "French",
    href: "https://uefadirect.uefa.com/192/fr"
  }, {
    code: "DE",
    text: "German",
    href: "https://uefadirect.uefa.com/192/de"
  }],
  "basePath": "/192/de",
  // "basePath": "",
  "companyLogo": "uefa-logo.png",
  "publishURL": "https://uefadirect.uefa.com/192/de/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-title\" style=\"top:784px; left:320px;\" src=\"/192/de/static/_content/1-title-1.png\">        \n        <img class=\"halfScaleC 1-logo\" style=\"top:-2px; left:566px;\" src=\"/192/de/static/_content/uefa-logo.png\">\n        <img class=\"halfScale 1-no\" style=\"top:107px; left:614px;\" src=\"/192/de/static/_content/1-sub-1.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n          .fromTo(cOf(\"1-no\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "Nr. 192  ZURÜCK IM SPIEL  HOFFNUNG FÜR DIE ZUKUNFT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 3-title\" style=\"top:307px; left:68px;\" src=\"/192/de/static/_content/3-title-1.png\">\n        <img class=\"halfScaleC 3-img\" style=\"top:14px; left:3px;\" src=\"/192/de/static/_content/3-img-1.png\">\n        <img class=\"halfScale 3-sub\" style=\"top:225px; left:78px;\" src=\"/192/de/static/_content/3-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(cOf(\"3-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"3-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n          .fromTo(cOf(\"3-sub\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "EDITORIAL  Theodore Theodoridis UEFA-Generalsekretär  LEHREN AUS EINER EINMALIGEN LEISTUNG  D  ie Geschichtsbücher des europäischen Fußballs wurden um ein weiteres bedeutendes Kapitel ergänzt. In weniger als zwei Monaten schloss die UEFA ihre Klubwettbewerbe 2019/20 erfolgreich ab, indem sie vier Turniere in vier verschiedenen Ländern organisierte und den UEFA-Superpokal 2020 in Budapest ausrichtete. Dies wäre für jeden Sportverband eine einmalige Leistung, die uns, ebenso wie die ganze beispiellose Saison, gewiss noch lange in Erinnerung bleiben wird. Vor diesem Hintergrund sollten wir innehalten und für die Herausforderungen, die vor uns liegen, Lehren ziehen. Der Erfolg der Turniere im August ist auf mehrere Schlüsselfaktoren zurückzuführen. In erster Linie sind das geeinte Auftreten, die Solidarität und die Anpassungsfähigkeit des europäischen Fußballs hervorzuheben – die UEFA, Klubs, Ligen und Nationalverbände zogen im Geiste der Zusammenarbeit und des Kompromisses an einem Strang und einigten sich in kürzester Zeit auf eine neue Terminplanung. Ferner leisteten die Ausrichterverbände durch ihre wertvolle organisatorische Erfahrung einen beachtlichen Beitrag; die Planung und die operativen Maßnahmen waren effizient, die umfassenden und zugleich notwendigen Vorkehrungen zum Gesundheitsschutz entfalteten ihre gewünschte Wirkung. Und nicht zuletzt boten uns die Mannschaften, Spielerinnen und Spieler auf dem Rasen eine Vielzahl spannender und dramatischer Begegnungen. Fans sind das Herzblut des Sports und daher ist es besonders schade, dass die geltenden Maßnahmen die Anzahl Zuschauer bei Fußballspielen weiterhin einschränken. Die Gesundheit und Sicherheit aller Beteiligten sind von entscheidender Bedeutung – wir müssen aber auch anerkennen, dass der Fußball ohne Fans einen Teil seiner Seele verliert. Daher beschloss das UEFA-Exekutivkomitee, dass der UEFA-Superpokal in Budapest als Pilotversuch mit einer geringen Anzahl an Zuschauern – zur Wahrung der Abstandsregeln lediglich 25 % der Stadionkapazität – dienen sollte, um die Auswirkungen der Zuschauerpräsenz auf das UEFA-Protokoll zur Wiederaufnahme des Spielbetriebs im Detail zu testen. Dabei standen wir in engem Austausch mit der ungarischen Regierung, um die Gesundheit aller Akteure und Zuschauer zu gewährleisten. Wir werden nun die gesundheitlichen Auswirkungen der Partie bewerten, bevor über das weitere Vorgehen im Hinblick auf UEFA-Spiele entschieden wird. Wissend, dass sich die Lage ständig weiterentwickelt, hoffen wir zudem, nach dem gedrängten Spielplan der letzten Zeit in den nächsten Monaten zu einem normalen Wettbewerbsrhythmus zurückzufinden. Außer Zweifel steht, dass wir dank dieser Erfahrungen und Herausforderungen künftig besser für besondere Umstände und Lagen aufgestellt und handlungsfähiger sein werden.  UEFA DIRECT • Viertes Quartal 2020 – 03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"halfScale 4-title-1\" style=\"top:130px; left:58px;\" src=\"/192/de/static/_content/4-title-1.png\">\n      <img class=\"halfScaleC 4-logo\" style=\"top:188px; left:21px;\" src=\"/192/de/static/_content/uefa-logo.png\">\n\n      <div class=\"addContentLink\" style=\"top:608px;left:203px;width:493px;height:64px\" onclick=\"Publish.goToPage(8)\"></div>\n      <div class=\"addContentLink\" style=\"top:690px;left:199px;width:233px;height:25px\" onclick=\"Publish.goToPage(19)\"></div>\n      <div class=\"addContentLink\" style=\"top:726px;left:199px;width:233px;height:57px\" onclick=\"Publish.goToPage(24)\"></div>\n      <div class=\"addContentLink\" style=\"top:786px;left:199px;width:233px;height:57px\" onclick=\"Publish.goToPage(32)\"></div>\n\n      <div class=\"addContentLink\" style=\"top:693px;left:437px;width:233px;height:57px\" onclick=\"Publish.goToPage(34)\"></div>\n      <div class=\"addContentLink\" style=\"top:761px;left:437px;width:233px;height:25px\" onclick=\"Publish.goToPage(37)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title-1\"), 0.6, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n          .fromTo(cOf(\"4-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "INHALT VIERTES QUARTAL 2020  Getty Images  INHALT  Offizielle Publikation der Europäischen Fußballunion  Chefredakteur: Emmanuel Deconche Stellvertretende Chefredakteurin: Dominique Maurer Leitender Redakteur: Mark Chaplin Externe Beiträge von: Graham Turner (Seiten 26-31) Simon Hart (Seiten 32-33, 34-35) Übersetzung: UEFA-Sprachdienste Layout und Realisierung: Touchline Druck: Artgraphic Cavin, CH-1422 Grandson Redaktionsschluss: 25. September 2020 Titelbilder: Getty Images  08 Wettbewerbe  Nach sechsmonatiger Zwangspause konnten die Klubwettbewerbe doch noch zu Ende gespielt werden.  19 Exekutivkomitee 24 Entwicklung Die UEFA veröffentlicht eine Studie über Trainingseinrichtungen für junge Spieler. Drucksache myclimate.org/01-20-403670  32 Forschungsstipendien-Programm Die kroatische Forscherin Rahela Jurković hat die Verbindungen zwischen Fußball und Flüchtlingen auf dem Balkan untersucht.  34 UEFA Grow Auftakt zu einem neuen Kapitel zum Thema Finanzen der Nationalverbände im Rahmen des Entwicklungsprogramms der UEFA.  37 Nachrichten der Mitgliedsverbände"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLink\" style=\"top:393px;left:65px;width:397px;height:67px\" onclick=\"Publish.goToPage(26)\"></div>\n      <div class=\"addContentLink\" style=\"top:402px;left:463px;width:169px;height:63px;\" onclick=\"Publish.goToPage(20)\"></div>\n      <div class=\"addContentLink\" style=\"top:783px;left:67px;width:183px;height:59px\" onclick=\"Publish.goToPage(6)\"></div>\n      <div class=\"addContentLink\" style=\"top:772px;left:256px;width:440px;height:66px\" onclick=\"Publish.goToPage(18)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "26 The Technician  06 Soziale Verantwortung  Für UEFA-Präsident Aleksander Čeferin hat der Kampf gegen Rassismus und Diskriminierung nichts an Aktualität eingebüßt.  20 Interview  Zbigniew Boniek, Mitglied des UEFA-Exekutivkomitees und polnische Fußballikone, im Gespräch.  Getty Images  Getty Images  Seit 25 Jahren veröffentlicht die UEFA technische Berichte über ihre Wettbewerbe, die auf den Erkenntnissen ihrer technischen Beobachter basieren.  UEFA  Shutterstock  INHALT  18 UEFA-Superpokal  In Budapest gewann Bayern München den zweiten UEFASuperpokal seiner Vereinsgeschichte.  UEFA DIRECT • Viertes Quartal 2020 – 05"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 6-title\" style=\"top:440px; left:59px;\" src=\"/192/de/static/_content/6-title-1.png\">\n        <img class=\"halfScale 6-sub\" style=\"top:563px; left:59px;\" src=\"/192/de/static/_content/6-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"6-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n        }\n      ",
    "searchText": "Getty Images  „EIN WECKRUF FÜR DIE GESELL­ SCHAFT UND DEN EUROPÄISCHEN FUSSBALL ALS GANZES“ UEFA-Präsident Aleksander Čeferin erklärt, warum es im Rahmen der Bemühungen der UEFA, Rassismus aus dem europäischen Fußball zu verbannen, so wichtig ist, Fußballerinnen und Fußballer zu ermutigen, offen über ihre persönlichen Erfahrungen im Zusammenhang mit Diskriminierung zu sprechen.  „  2  020 ist ein Jahr, in dem Bürgerinnen und Bürger auf der ganzen Welt aktiv geworden sind, um auf zwei außerordentliche Ereignisse zu reagieren: erstens den Schutz unserer Familien und der Gesellschaft vor der globalen COVID19-Pandemie und zweitens das Eintreten für gleiche Rechte und Gerechtigkeit für alle. Es ist ein Weckruf für die Gesellschaft und den europäischen Fußball als Ganzes. Es ist eine Tatsache, dass Milliarden Fans dem Fußball mitunter mehr Aufmerksamkeit schenken als ihren gewählten Politikerinnen und Politikern. In einer Krise bedeutet ein solch enormer Einfluss und  06 – UEFA DIRECT • Viertes Quartal 2020  eine solche Reichweite zusätzliche Verantwortung und ich bin stolz darauf, wie der europäische Fußball in Zeiten der Not den Menschen zur Seite gestanden hat. Seit März haben Nationalverbände, Vereine sowie Fußballerinnen und Fußballer auf dem gesamten Kontinent Spenden gesammelt, um lebensrettende medizinische Ausrüstung zu kaufen sowie älteren und gefährdeten Menschen Lebensmittel zuzustellen; ferner haben sie den Behörden geholfen, wichtige Botschaften zum Schutz der Gesundheit zu verbreiten. Dies zeigt erneut, wie der Fußball in der Lage ist, mit allen Menschen, unabhängig von ihrer Hautfarbe, ihrem Geschlecht und ihrer  Glaubensrichtung, zu kommunizieren und sich mit ihnen zu vernetzen. Gleichzeitig haben sich Vereine sowie Spielerinnen und Spieler solidarisch mit dem Leid, der Wut und der Trauer der Menschen nach dem tragischen Tod von George Floyd in den USA gezeigt. Athletinnen und Athleten verschiedenster Sportarten haben sich eindringlich dazu geäußert, dass jetzt der Augenblick für die Regierungen gekommen sei, ihre Programme gegen Rassismus zu überdenken. Verantwortung der UEFA Die UEFA hat sich ihrer Verantwortung schon immer gestellt, jegliche Form von"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-quote\" style=\"top:718px; left:72px;\" src=\"/192/de/static/_content/7-quote-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:639px;left:453px;width:80px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/video/0260-100ea96d11da-d249abf9eb5b-1000--kalidou-koulibaly-s-no-to-racism-message/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:639px;left:552px;width:62px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/video/0260-100ea96d11da-d68b69305f4c-1000--nadia-nadim-s-no-to-racism-message/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "SOZIALE VERANTWORTUNG  Notwendigkeit gemeinsamen Handelns Allerdings ist im Angesicht der jüngsten Ereignisse klar, dass Sensibilisierung alleine nicht ausreicht. Zusammen mit allen Beteiligten im europäischen Fußball müssen wir unseren Sport weiterentwickeln und einen qualitativ anderen Ansatz finden, um systembedingten Rassismus aus dem Fußball zu eliminieren. Selbst für einen Dachverband wie die UEFA ist das keine leichte Aufgabe. Rassismus und Diskriminierung sind in der Gesellschaft tief verwurzelt. Ohne ein abgestimmtes Handeln von Regierungen und nationalen Einrichtungen wie Schulen wird sich in diesem Zusammenhang nichts ändern. Dies darf jedoch keine Entschuldigung dafür sein, dass sich der Fußball seiner Verantwortung entzieht. Mit 55 Mitgliedsverbänden und Millionen Zuschauern ist die UEFA gut aufgestellt, Fans, Spielerinnen und Spieler, Vereine, Ligen, Dachverbände und Medien zu verbinden und koordiniert aufzutreten. Um Rassismus auszumerzen, müssen wir zusammenstehen und gemeinsam handeln.  UEFA  Rassismus im europäischen Fußball zu bekämpfen und konkrete Schritte gegen die unerträgliche Verwendung rassistischer Sprache gegen Spielerinnen und Spieler zu ergreifen. Abseits des Rasens arbeiten wir Hand in Hand mit Nicht-Regierungsorganisationen wie Fußball gegen Rassismus in Europa (FARE), einem Netzwerk aus Fanklubs, Spielergewerkschaften, Fußballverbänden und ethnischen Minderheitengruppen, das sich in ganz Europa gegen Rassismus und Ungleichheit einsetzt. Im Rahmen dieser Zusammenarbeit wurden die UEFA-Richtlinien zu bewährten Vorgehensweisen im Kampf gegen Rassismus für Vereine und Nationalverbände weiter ausgearbeitet, darunter ein Zehn-Punkte-Plan, der im Zentrum unseres Auftrags zum Schutz des Fußballs steht. Auf dem Rasen erhalten die Unparteiischen anhand des dreistufigen Verfahrens der UEFA das Recht, Spiele im Fall von rassistischen Vorfällen zu unteroder gar abzubrechen. Ferner nutzt die UEFA – wie sie dies auch im August getan hat – die globale Reichweite ihrer Wettbewerbe, um die Botschaft „Nein zu Rassismus“ zu verbreiten.  „Mit 55 Mitgliedsverbänden und Millionen Zuschauern ist die UEFA gut aufgestellt, Fans, Spielerinnen und Spieler, Vereine, Ligen, Dachverbände und Medien zu verbinden und koordiniert aufzutreten. Um Rassismus auszumerzen, müssen wir zusammenstehen und gemeinsam handeln.“ Aleksander Čeferin UEFA-Präsident  Verstehen, wie Rassismus im Sport tatsächlich funktioniert In einem ersten Schritt muss der Ansatz der UEFA und des europäischen Fußballs weiterentwickelt werden. Dafür müssen wir die jüngsten emotionalen Äußerungen von Fußballerinnen und Fußballern sowie Fans, die ihren Frust aus Angst vor Repressalien zu lange zurückgehalten haben, als Grundlage nutzen. Wir müssen nicht nur eine offene Debatte über Vielfalt und Einbindung führen, sondern ein tiefgreifendes Verständnis dafür entwickeln, wie Rassismus die verschiedenen Ebenen des Fußballs durchdringt: von oben nach unten, von der Vorstandsetage bis auf das Trainingsgelände junger Nachwuchstalente. Dies ist keine angenehme Aufgabe, aber wir werden keine anderen Lösungen finden, ohne zunächst zu identifizieren, was nicht funktioniert. Es bedeutet, Einzelne aufzufordern, weiter offen über Rassismus im Fußball zu sprechen, selbst wenn das Thema aus den Schlagzeilen verschwunden ist. Als Zeichen dafür, dass die UEFA verstanden hat, wie wichtig es ist, zunächst zuzuhören und aus dem Gehörten zu lernen, bevor ein neuer Ansatz entwickelt werden kann, haben wir zahlreiche aktuelle und ehemalige Spitzenspielerinnen und ‑spieler gebeten, über ihre eigenen Erfahrungen mit Rassismus zu sprechen – aus Kinderund Profizeiten. Ich selbst war überrascht, wie früh Rassismus die Fußballträume eines kleinen Jungen oder Mädchens untergraben kann. All diese Spielerinnen und Spieler haben Diskriminierung überwunden, um ihre Ziele zu erreichen, aber ich habe mich gefragt, wie vielen anderen potenziellen Kalidou Koulibalys oder Nadia Nadims die Energie geraubt wurde, stereotype Kommentare oder Bemerkungen auf Grundlage ihrer Hautfarbe, Nationalität, Religion, sexuellen Orientierung oder ihres Geschlechts zu überwinden. Deshalb verweisen viele Spielerinnen und Spieler immer wieder auf dieselbe Lösung, wenn sie ihre persönliche Perspektive darüber teilen, wo der Fußball mehr Zeit und Ressourcen investieren soll, um einen echten Unterschied zu machen: Die Beliebtheit des Fußballs als Massensport muss dafür genutzt werden, Familien, Trainer, die Gesellschaft und vor allem Kinder entsprechend zu sensibilisieren.“ UEFA DIRECT • Viertes Quartal 2020 – 07"
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n      <img class=\"halfScale 8-title\" style=\"top:162px; left:59px;\" src=\"/192/de/static/_content/8-title-1.png\">\n      <img class=\"halfScale 8-sub\" style=\"top:278px; left:59px;\" src=\"/192/de/static/_content/8-sub-1.png\">\n      "), defineProperty_default()(_ref, "script", "\n      \n      function onPageEnter() {\n        pg8Anim = new TimelineMax();\n        pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"8-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg8Anim.stop();\n      }\n      "), defineProperty_default()(_ref, "searchText", "ENDLICH WIEDER FUSSBALL  Getty Images  Im August wurde der Spielbetrieb in den UEFA-Klubwettbewerben wieder aufgenommen. Innerhalb von vier Wochen fanden in vier Ländern und vier Wettbewerben über 40 Begegnungen statt. Wie konnte das alles organisiert werden?  Z  In Rekordzeit wurden die nötigen Vorkehrungen getroffen, um die Europa League in Deutschland (Köln, oben) und die Champions League in Portugal (Lissabon, rechts) abzuschließen.  08 – UEFA DIRECT • Viertes Quartal 2020  waren, diese außergewöhnlichen Turniere auszurichten. Ergänzt wurde das Konzept durch den Abschluss der Youth League, der wie gewöhnlich im Colovray-Stadion am UEFA-Sitz in Nyon erfolgte, aber in diesem Jahr zusätzlich zu den üblichen Halbfinalbegegnungen und dem Endspiel auch das Viertelfinale und die letzte noch ausstehende Achtelfinalpartie umfasste.  Auswahl geeigneter Partner Ehrgeizige Pläne aufzustellen ist das eine, sie erfolgreich umzusetzen das andere. Hierfür sind Teamwork, unermüdliche Planung und eine Reihe von Schlüsselakteuren von herausragender Bedeutung, und kein Element war dabei wichtiger als die drei Nationalverbände, die als Gastgeber für die Finalturniere der A-Klubwettbewerbe fungieren sollten:  Getty Images  “  unächst einmal ging es in den letzten Tagen und Monaten extrem hektisch zu. Wir haben wenig geschlafen. Aber letztendlich war es sehr wichtig, das durchzuziehen – zu zeigen, dass der Fußball weitergeht.“ So blickt UEFA-Präsident Aleksander Čeferin auf die Fortsetzung der UEFA-Wettbewerbe in verändertem Format im August zurück, nachdem Mitte März sämtliche Wettbewerbe gestoppt worden waren und die EM-Endrunde 2020 um ein Jahr verschoben wurde. Damals hätten wohl die Wenigsten geglaubt, dass UEFA Champions League, UEFA Europa League, UEFA Youth League und UEFA Women’s Champions League durch ein so innovatives und einzigartiges Format wie das „Final Eight“ in diesem Jahr noch zu Ende gebracht werden würden. Im Mai begannen die Diskussionen darüber, was möglich sein könnte und was zur Durchführung von Spielen an neutralen Austragungsorten nötig wäre. Bis zur Sitzung des UEFA-Exekutivkomitees am 17. Juni waren drei potenzielle Ausrichterverbände ausgemacht worden, die in der Lage und willens"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WETTBEWERBE  Getty Images  Getty Images  Antoine Griezman und Ousmane Dembélé vom FC Barcelona mit Maske bei der Ankunft im Stadion vor dem Viertelfinale.  Die Teams von Olympique Lyon und Bayern München vor dem Viertelfinale der UEFA Women’s Champions League in Bilbao.  Deutschland, Portugal und Spanien. In einem normalen Jahr nimmt die Planung eines UEFA-Klubwettbewerbsfinales zwölf Monate in Anspruch – 2020 wurde diese Aufgabe in gerade einmal zwei Monaten bewältigt. Der Präsident des Portugiesischen Fußballverbands (FPF), Fernando Gomes, erklärte, was Lissabon zum idealen Ort für die Endrunde der europäischen Königsklasse machte. „Die Champions League kann jederzeit in Portugal stattfinden, da unsere Klubs in ausgezeichnete Infrastruktur investieren und diese sehr gut instand halten. Nicht nur Stadien, sondern auch Trainingszentren, die bei diesem nie dagewesenen Format [Final Eight] von großer Bedeutung sein werden.“ FPF-Direktor Daniel Ribeiro ergänzte: „Da Zeit in diesem Fall ein Luxus ist, den wir uns nicht leisten können, sind eine schnelle Planung und klare, gemeinschaftliche Entscheidungen erforderlich, um einen Event abzuliefern, der so wirkt, als sei er über Jahre vorbereitet worden.“ Deutschland war für die Ausrichtung der Europa-League-Schlussphase ebenfalls gut aufgestellt, da die nationalen Wettbewerbe früh wieder begonnen hatten und erstklassige Stadien sowie eine geeignete Verkehrsinfrastruktur, Hotels und Trainingsanlagen vor-  handen sind. Nordrhein-Westfalen entpuppte sich mit seiner hohen Stadiondichte schnell als die perfekte Region für die verbleibenden Partien des Wettbewerbs. DFB-Präsident Fritz Keller sagte: „Wir sind sehr stolz, dass die UEFA sich für Deutschland und Nordrhein-Westfalen als Austragungsort der Europa-League-Endrunde entschieden hat und uns diese anspruchsvolle Aufgabe anvertraut. Wir haben die nötige Infrastruktur und Erfahrung, um ein Turnier dieser Dimension zu organisieren und durchzuführen. Zudem haben unser medizinisch-organisatorisches Konzept und die ordnungsgemäße Umsetzung durch die Klubs das Vertrauen in den DFB als Ausrichter noch einmal gestärkt. Auch diese Entscheidung spiegelt das hohe Ansehen des deutschen Fußballs in der europäischen Fußball-Gemeinschaft wider.“ Ein Hoffnungsschimmer Derweil sendete das Turnier in Spanien ein Signal der Hoffnung für den ganzen Frauenfußball. Lediglich die deutsche Bundesliga hatte die Saison gemäß ihrem ursprünglichen Zeitplan abschließen können, was bedeutete, dass sechs der acht Endrundenteilnehmer der UEFA Women’s Champions League zum Zeitpunkt des Turnierbeginns am 21. August – fast 300 Tage nach der letzten Achtelfinal-  begegnung – monatelang ohne Spielpraxis gewesen waren. Auch mit dem Spanischen Fußballverband (RFEF), ähnlich erfahren in der Organisation von Großveranstaltungen wie die deutschen und portugiesischen Kollegen, arbeitete die UEFA vertrauensvoll zusammen. Es konnten zwei nicht weit voneinander entfernt gelegene Stadien gefunden werden, die geeignet waren, die letzten Spiele unter diesen ungewöhnlichen Umständen durchzuführen. In Absprache mit den beteiligten Mannschaften und der Europäischen Klubvereinigung (ECA) wurde sichergestellt, dass die Turnierlösung für alle Endrundenteilnehmer ein gangbarer Weg wäre. Dies betraf zum einen die logistische Notwendigkeit, dass die Spielerinnen vor und während des Turniers in ihrer eigenen „Blase“ bleiben würden, zum anderen den Saisonabschluss im August trotz der Tatsache, dass die Verträge einiger Schlüsselspielerinnen im Juni ausliefen und bereits Transfers getätigt worden waren. Kooperationsbereitschaft war auch hier das Schlüsselwort, um den Frauenwettbewerb in einem sicheren Rahmen fortführen zu können. Mut und Entschlossenheit „Ich weiß auch nicht, warum, aber wir sind die einzige Organisation weltweit, die zeitgleich vier internationale Veranstaltungen in vier verschiedenen Ländern auf die Beine stellt“, führte der UEFA-Präsident aus. „Nicht nur der einzige Sportverband, sondern die einzige Organisation überhaupt. Ich denke, wenn man mutig und entschlossen genug ist, wird man es am Ende schaffen, und es sieht aus, als sei unsere Entscheidung letzten Endes die richtige gewesen.“ Es wurde eine vierwöchige Erfolgsgeschichte – zum guten Schluss konnten doch noch die Champions dieser Spielzeit ermittelt werden und die Fans rund um den Globus bekamen dank des hochspannenden Formats mit Entscheidungen in nur einer Partie beste Unterhaltung geboten. Doch wenngleich der Saisonabschluss gelungen ist, bleibt wenig Zeit, sich auf den Lorbeeren auszuruhen. „Es war nicht leicht; wahrscheinlich hatten wir auch eine gute Portion Glück. Man muss aber auch bedenken, dass es nicht nur um diese vier Turniere ging“, so Aleksander Čeferin weiter. „Da sind die Qualifikationsrunden der europäischen Klubwettbewerbe, Anfang September wollen wir mit den Nationalmannschaftswettbewerben beginnen – es liegen auch noch fordernde Zeiten vor uns.“ UEFA DIRECT • Viertes Quartal 2020 – 09"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 10-title\" style=\"top:129px; left:58px;\" src=\"/192/de/static/_content/10-title-1.png\">\n      <img class=\"halfScale 10-sub\" style=\"top:176px; left:58px;\" src=\"/192/de/static/_content/10-sub-1.png\">\n\n      <a href=\"https://www.uefa.tv/match/vod/162201/2030150\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:23px;left:134px;\" src=\"/192/de/static/_content/play.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:43px;left:443px;width:119px;height:20px;\">\n        <a href=\"/static/_content/Champions-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.fromTo(cOf(\"10-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"10-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "EIN BAYERN-FEST Nach Monaten des Wartens wurden im August die europäischen Klubwettbewerbe in vier Ländern wieder aufgenommen. In der Champions League bildete Lissabon die Kulisse für ein spektakuläres Finalturnier, bei dem drei Klubs ohne Titel in der Königsklasse der Einzug ins Halbfinale gelang. Schlussendlich konnte Bayern München seine Erfahrung in den Titelgewinn ummünzen.  Getty Images  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  1 Thomas Müller im Zweikampf mit Jason Denayer beim Halbfinale zwischen Olympique Lyon und Bayern München. 2 Nach dem Titelgewinn der Bayern 2013 ist es der zweite ChampionsLeague-Sieg für Manuel Neuer.  Getty Images  2  3 Der ehemalige Pariser Kingsley Coman verhilft den Bayern mit einem starken Kopfball zum Triumph.  3 UEFA DIRECT • Viertes Quartal 2020 – 11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  4 5 6 Getty Images  4 PSG-Spieler Neymar in Aktion beim Halbfinale gegen RB Leipzig.  6 Manchester-CityStürmer Gabriel Jesus versucht, im Viertelfinale gegen Lyon den Ball zu kontrollieren.  Getty Images  5 Olympique Lyon hat auf seinem beeindruckenden Weg ins Halbfinale Juventus Turin und Manchester City geschlagen.  UEFA CHAMPIONS LEAGUE Viertelfinale (12.-15. August) Manchester City - Olympique Lyon RB Leipzig - Atlético Madrid FC Barcelona - Bayern München Atalanta Bergamo - Paris Saint-Germain  1:3 2:1 2:8 1:2  (0:1) (0:0) (1:4) (1:0)  Halbfinale (18./19. August) RB Leipzig - Paris Saint-Germain Olympique Lyon - Bayern München  0:3 0:3  (0:2) (0:2)  Finale (23. August) Paris Saint-Germain  0:1  (0:0)  - Bayern München  12 – UEFA DIRECT • Viertes Quartal 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 13-title\" style=\"top:126px; left:71px;\" src=\"/192/de/static/_content/13-title-1.png\">\n        <img class=\"halfScale 13-sub\" style=\"top:192px; left:71px;\" src=\"/192/de/static/_content/13-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/video/vod/163075/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:45px;left:52px;\" src=\"/192/de/static/_content/play-green.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:63px;left:439px;width:75px;height:28px;\">\n          <a href=\"/static/_content/Youth-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.fromTo(cOf(\"13-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"13-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "Real-Madrid-Junioren auf den Spuren der ersten Mannschaft UEFA  Die junge madrilenische Mannschaft unter Raúl González hat erstmals das Pendant der Champions League bei den Junioren gewonnen. Gespielt wurde unweit des Hauses des europäischen Fußballs im schweizerischen Nyon.  2  1 Real-Madrid-Kapitän Victor Chust stemmt den ersten YouthLeague-Pokal für den spanischen Klub in die Höhe.  UEFA  2 Infolge der COVID-19Pandemie wurden die Viertelfinalpartien der Youth League im Stade de Colovray in Nyon ausgetragen (hier die Partie zwischen Dinamo Zagreb und Benfica Lissabon).  1 3  3 Der Madrilene Óscar Aranda im Luftduell mit Benfica-Spieler Tiago Araúji.  UEFA YOUTH LEAGUE Viertelfinale (18./19. August) Inter Mailand Real Madrid Olympique Lyon FC Salzburg FC Midtjylland Ajax Amsterdam Dinamo Zagreb Benfica Lissabon  0:3 4:3 1:3 1:3  (0:0) (2:1) (0:1) (1:1)  Halbfinale (22. August) Benfica Lissabon FC Salzburg -  Ajax Amsterdam Real Madrid  3:0 1:2  (1:0) (0:2)  Finale (25. August) Benfica Lissabon  Real Madrid  2:3  (0:2)  -  UEFA  UEFA DIRECT • Viertes Quartal 2020 – 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 14-title\" style=\"top:777px; left:59px;\" src=\"/192/de/static/_content/14-title-1.png\">\n        <img class=\"halfScale 14-sub\" style=\"top:817px; left:58px;\" src=\"/192/de/static/_content/14-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/match/vod/162004/2030143\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:700px;left:106px;\" src=\"/192/de/static/_content/play-yellow.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:808px;left:509px;width:71px;height:31px;\">\n          <a href=\"/static/_content/Europa-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"14-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg14Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "Sevilla, wer sonst? In Köln machten die Andalusier bei ihrer sechsten Endspielteilnahme das halbe Titeldutzend voll.  14 – UEFA DIRECT • Viertes Quartal 2020  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  2  1 Spektakulärer Abschluss von Fernando vom FC Sevilla beim Endspiel gegen Inter Mailand. 2 Gewohntes Bild bei der Pokalübergabe: Von den fünfzehn letzten Ausgaben des UEFA-Pokals bzw. der UEFA Europa League hat der FC Sevilla 40 % für sich entschieden.  Getty Images  3 Manchester United (Paul Pogba) setzte sich im Viertelfinale gegen den FC Kopenhagen (Rasmus Falk) durch.  3 4  1:0  (0:0)  2:1 4:1 0:1  (2:1) (2:0) (0:0)  nach Verlängerung  Halbfinale (16./17. August) FC Sevilla Inter Mailand  -  Manchester United Schachtar Donezk  2:1 5:0  (1:1) (1:0)  Final (21. August) FC Sevilla  -  Inter Mailand  3:2  (2:2)  Getty Images  Getty Images  UEFA EUROPA LEAGUE Viertelfinale (10./11. August) Manchester United FC Kopenhagen 			 Inter Mailand Bayer Leverkusen Schachtar Donezk FC Basel Wolverhampton Wanderers FC Sevilla  4 Aufgrund der Pandemie galten bei den Interviews strikte Abstandsregeln.  UEFA DIRECT • Viertes Quartal 2020 – 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 16-title\" style=\"top:762px; left:58px;\" src=\"/192/de/static/_content/16-title-1.png\">\n      <img class=\"halfScale 16-sub\" style=\"top:793px; left:58px;\" src=\"/192/de/static/_content/16-sub-1.png\">\n      \n      <a href=\"https://www.uefa.tv/video/vod/163148/?bucketName=2019%2F20%20SEASON%20REVIEW&section=UWCL\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:680px;left:97px;\" src=\"/192/de/static/_content/play-purple.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:646px;left:336px;width:124px;height:20px;\">\n        <a href=\"/static/_content/Womens-CL_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg16Anim = new TimelineMax();\n        pg16Anim.fromTo(cOf(\"16-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"16-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg16Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "2 1  Hungrige Löwinnen Das immer wieder hungrige Team von Olympique Lyon hat in Spanien mit seinem fünften Women’s-ChampionsLeague-Titel in Folge (und seinem siebten Titel insgesamt) seine Dominanz in Europa bestätigt. 16 – UEFA DIRECT • Viertes Quartal 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  1 Olympique Lyon eilt mit seiner Spielführerin Wendie Renard (mit dem Pokal) von einem Rekord zum nächsten. 2 Turid Knaak (Atlético Madrid) im Estadio de San Mamés in Bilbao im Zweikampf mit Lieke Martens (FC Barcelona). Das rein spanische Viertelfinale endete mit einem Sieg der Katalaninnen. 3 Kopfballduell zwischen Giulia Gwinn (links, Bayern München) und Sara Gunnarsdóttir (Olympique Lyon) im Viertelfinale im Estadio de San Mamés.  3  4 Ewa Pajor (VfL Wolfsburg) mit einer akrobatischen Einlage im Halbfinale gegen den FC Barcelona im Estadio Anoeta in San Sebastián.  Viertelfinale (21./22. August) Atlético Madrid - FC Barcelona Olympique Lyon - FC Bayern München Glasgow City - VfL Wolfsburg Arsenal Women - Paris Saint-Germain  0:1 2:1 1:9 1:2  (0:0) (1:0) (0:4) (1:1)  Halbfinale (25./26. August) Paris Saint-Germain - Olympique Lyon VfL Wolfsburg - FC Barcelona  0:1 1:0  (0:0) (0:0)  Endspiel (30. August) VfL Wolfsburg  1:3  (0:2)  - Olympique Lyon  Getty Images  Getty Images  Getty Images  UEFA Women’s Champions League  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 18-title\" style=\"top:124px; left:57px;\" src=\"/192/de/static/_content/18-title-1.png\">\n      <img class=\"halfScale 18-sub\" style=\"top:246px; left:58px;\" src=\"/192/de/static/_content/18-sub-1.png\">\n\n      <a href=\"https://www.uefa.com/insideuefa/video/0259-0f842297fc14-2036bf494a63-1000--2020-uefa-super-cup-match-ball-designed-by-children/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:761px;left:600px;\" src=\"/192/de/static/_content/play-purple.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:768px;left:602px;width:14px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:780px;left:440px;width:171px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:792px;left:440px;width:150px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:804px;left:440px;width:163px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:816px;left:440px;width:180px;height:12px;\">\n        <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"top:828px;left:440px;width:117px;height:12px;\">\n        <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg18Anim = new TimelineMax();\n        pg18Anim.fromTo(cOf(\"18-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"18-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg18Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "BAYERN MÜNCHEN TRIUMPHIERT AUCH IN BUDAPEST  E  rstmals seit der pandemiebedingten Aussetzung ihrer Wettbewerbe im vergangenen März ließ die UEFA beim Superpokal in der Puskás Aréna in Budapest am 24. September eine begrenzte Anzahl Fans zu. Zu den Zuschauern bei der Partie zwischen Champions-League-Sieger Bayern München und Europa-League-Gewinner FC Sevilla gehörten unter anderem auch 500 vom Ungarischen Fußballverband (MLSZ) geladene Beschäftigte aus dem örtlichen Gesundheitswesen, als Dank für ihren Einsatz an vorderster Front. Bei einer Gesamtkapazität von 60 000 Plätzen war das Stadion mit 15 500 Zuschauerinnen und Zuschauern nur spärlich gefüllt, was der Absicht der Veranstalter entsprach: Bei einer Auslastung von 25 % konnte die Einhaltung der Abstandsregeln gewährleistet werden. Im Rahmen dieses Pilotprojekts zur Erörterung der Auswirkungen von Fans auf das medizinische und operative UEFA-Protokoll zur Wiederaufnahme des Spielbetriebs ergriffen der europäische Dachverband und der MLSZ umfassende Maßnahmen zur Vermeidung von Ansteckungen. Vor dem Passieren des äußeren Sicherheitsbereichs mussten die Zuschauer ihre Körpertemperatur messen lassen und wurden aufgefordert,  18 – UEFA DIRECT • Viertes Quartal 2020  Getty Images  Keine vier Wochen nach Abschluss der Saison 2019/20 stand der UEFA-Superpokal auf dem Programm. Die traditionelle Auftaktveranstaltung zur neuen Spielzeit fand dieses Jahr unter stark veränderten Vorzeichen statt – für die Fans war aber dennoch ein Hauch von Normalität spürbar.  eine Maske zu tragen, falls sie die empfohlenen Abstände nicht einhalten können. Außerdem wurden für das Anstehen bei den Drehkreuzen und Verpflegungsständen spezielle Markierungen angebracht. UEFA-Präsident Aleksander Čeferin sagte am Tag des Spiels: „Die Gesundheit ist unsere höchste Priorität, doch wir wollen auch Hoffnung vermitteln und das tun, was wir für richtig halten. Für uns wäre es einfacher, nichts zu tun, doch dann kommt nichts voran.“ Auf dem Rasen holten die Bayern ihren vierten Pokal des Jahres und zeigten, dass sie weiter titelhungrig sind. Sevilla war allerdings ein ebenbürtiger Gegner und ging sogar früh in Führung, bevor der deutsche Meister kurz vor der Pause zum Ausgleich kam. Danach verpassten es die Münchner, ihre Feldüberlegenheit in Tore umzumünzen, bevor schließlich Javi Martínez in der Verlängerung per Kopf zum 2:1 traf. Es war der zwölfte Bayern-Sieg in Folge auf europäischer Bühne und das 25. Mal in 45 Ausgaben, dass der Gewinner der Königsklasse den Saisonauftakt für sich entscheiden konnte. Der Superpokal war im Rahmen der Neuausrichtung des Fußballkalenders im Juni nach Budapest verlegt worden. Im Zuge  seiner Anstrengungen zur Steigerung der Teilnehmerzahlen hofft der MLSZ, dass die Ausrichtung dieses prestigeträchtigen Duells zweier europäischen Spitzenteams in der prächtigen Puskás Aréna eine neue Generation ungarischer Jugendlicher über die Hauptstadt hinaus für den Fußball begeistern wird. Der Verband hat sich zum Ziel gesetzt, dass niemand in Ungarn weiter als zehn Kilometer von einem qualitativ guten Fußballplatz wohnen soll. Dafür hat er in den letzten zehn Jahren knapp 3 000 Spielfelder errichtet oder renoviert. In derselben Zeitspanne hat sich die Zahl gemeldeter Breitenfußballer auf fast 300 000 verdreifacht – 30 000 davon sind Mädchen. In den letzten Jahren haben Kinder bei der Superpokal-Eröffnungszeremonie eine Hauptrolle eingenommen. Angesichts der aktuellen Umstände konnte die UEFA-Stiftung für Kinder leider nicht im üblichen Rahmen aktiv sein, doch die jüngsten Fans leisteten dennoch einen Beitrag zum Event, genauer gesagt zum offiziellen Spielball: Im Rahmen eines europaweiten Wettbewerbs konnten Schulkinder Designs für den offiziellen Ball entwerfen – die zehn von der Jury ausgewählten Zeichnungen wurden auf dem Spielgerät verewigt."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 19-title\" style=\"top:129px; left:71px;\" src=\"/192/de/static/_content/19-title-1.png\">\n        <img class=\"halfScale 19-sub\" style=\"top:214px; left:71px;\" src=\"/192/de/static/_content/19-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"19-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg19Anim.stop();\n        }\n      ",
    "searchText": "EXEKUTIVKOMITEE  NEUER SPIELKALENDER UND SPEZIFISCHE MASSNAHMEN Bei seiner jüngsten Sitzung in Budapest am 24. September hat das UEFA-Exekutivkomitee verschiedene Entscheidungen getroffen und eine Reihe von Maßnahmen und Bestimmungen eingeführt, die der aktuellen Situation Rechnung tragen sollen.  N  ach Absprache mit der Europäischen Klubvereinigung und den European Leagues beschloss das Exekutivkomitee, die Spieltage nachzuholen, die aufgrund der COVID-19-bedingten Absage der Länderspielperiode im März 2020 sowie der Verschiebung der EURO 2020 auf den nächsten Sommer fehlen. Durch die Verlängerung der im März und September 2021 angesetzten Länderspielperioden im internationalen Spielkalender der FIFA können in diesen beiden Zeiträumen jeweils drei statt zwei Spiele organisiert werden. Überarbeiteter Spielkalender für die europäischen Nationalmannschaftswettbewerbe (vorbehaltlich der Genehmigung durch die FIFA) 22.-31. März 2021: drei Spieltage 31. Mai - 8. Juni 2021: Freundschaftsspiele zur Vorbereitung auf die EURO 2020 30. August - 8. September 2021: drei Spieltage 4.-12. Oktober 2021: zwei Spieltage 8.-16. November 2021: zwei Spieltage 21.-29. März 2022: zwei Spieltage für die Playoffs der European Qualifiers  Die Endphase der UEFA Nations League wird im Oktober 2021 ausgetragen; sie umfasst die Halbfinalspiele (6./7. Oktober), das Spiel um den dritten Platz sowie das Endspiel (10. Oktober). Drei Verbände aus Gruppe 1 (Italien, Niederlande und Polen) haben ihr Interesse an der Ausrichtung der Endphase bekundet. Fünf Auswechslungen Für den Rest der Saison sind in allen Spielen der UEFA Nations League, der Playoffs der European Qualifiers, der Qualifikation zur UEFA Women’s EURO, der UEFA Champions League und der UEFA Europa League (ab Gruppenphase) sowie der UEFA Women’s Champions League bis zu fünf Auswechslungen zugelassen. Dadurch sollen die Spielerinnen und Spieler aufgrund des dicht gedrängten Spielkalenders 2020/21 entlastet werden. Das Verfahren zur Erstellung des Spielplans für den europäischen Qualifikationswettbewerb zur FIFA-WM 2022 wurde unter Berücksichtigung von Aspekten wie Winterspielorte, Reisedistanzen, Abfolge von Heim- und Auswärtsspielen sowie Anzahl Mannschaften pro Gruppe genehmigt.  Spezifische Bestimmungen Vor dem Hintergrund der COVID-19-Krise wurden spezifische Maßnahmen für die Playoff-Begegnungen zur UEFA EURO 2020 getroffen, die das Teilnehmerfeld vervollständigen werden. Spezifische Bestimmungen wurden auch für die Organisation der Spiele in der Gruppenphase der UEFA Champions League und der UEFA Europa League verabschiedet. Angesichts des neuen Formats und Spielkalenders für die UEFA Women’s Champions League 2020/21 wurden sowohl das überarbeitete Wettbewerbsreglement als auch spezifische Bestimmungen genehmigt, die das allgemeine Vorgehen, die Auswirkungen und die Verantwortlichkeiten mit Blick auf die Organisation der Spiele im Fall von Reisebeschränkungen oder positiven COVID-19-Tests klären sollen. Auch die UEFA Youth League 2020/21 erhält aufgrund der fortbestehenden Schwierigkeiten, den Wettbewerb in der aktuellen Situation zu organisieren, ein neues Format. Die Runden ab dem Zweiunddreißigstelfinale im März 2021 finden jeweils in einer einzigen K.-o.-Partie statt.  Getty Images  Alle UEFA-Veranstaltungen in der Schweiz Schließlich hat das Exekutivkomitee beschlossen, dass alle UEFA-Veranstaltungen der nächsten sechs Monate aufgrund der aktuellen Beschränkungen sowie zur Verringerung des organisatorischen Aufwands in der Schweiz stattfinden werden. Dies gilt insbesondere für die kommenden Sitzungen des Exekutivkomitees im Dezember und März sowie für den ordentlichen UEFA-Kongress im März 2021.  Das Exekutivkomitee hat bis zum Ende der Saison jeweils bis zu fünf Auswechslungen bei UEFAWettbewerbsspielen genehmigt.  UEFA DIRECT • Viertes Quartal 2020 – 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 20-title\" style=\"top:166px; left:64px;\" src=\"/192/de/static/_content/20-title-1.png\">\n        <img class=\"halfScale 20-sub\" style=\"top:284px; left:64px;\" src=\"/192/de/static/_content/20-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"20-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg20Anim.stop();\n        }\n      ",
    "searchText": "INTERVIEW  ZBIGNIEW BONIEK  „TALENT IST WICHTIG, ABER OFT IST ES EHER EIN HINDERNIS ALS EINE HILFE“ Im Fußball hat es kaum je etwas Schöneres gegeben, als Zbigniew Boniek auf dem Spielfeld in voller Fahrt zu sehen – vor allem in den magischen Nächten Europas in den 1980er-Jahren, als er Juventus half, die Fußballgipfel des Kontinents zu erklimmen. Sein Tempo, seine Beschleunigung, seine Technik und seine Torgefährlichkeit, insbesondere unter Flutlicht, brachten ihm von JuventusPräsident Gianni Agnelli den Spitznamen „Bello di notte“ (Schönheit der Nacht) ein.  D  PresseSports  er im polnischen Bydgoszcz geborene Boniek spielte zunächst für seinen Heimatklub Zawisza Bydgoszcz, bevor er zu Widzew Łódź wechselte, wo er zwei polnische Titel gewann. 1982 wechselte er zum italienischen Fußballriesen Juventus, wo er zu einer tragenden Säule einer großartigen Mannschaft der Bianconeri wurde, die 1984 den Europapokal der Pokalsieger und den UEFA-Superpokal sowie 1985 den Pokal der europäischen Meistervereine gewann. Seine Spielerkarriere beendete er 1988 beim AS Rom. Im Alter von 20 Jahren debütierte Boniek in der polnischen Nationalmannschaft, mit der er an den Weltmeisterschaften 1978, 1982 und 1986 teilnahm. Besonders erfolgreich war er 1982 in Spanien, als ihm gegen Belgien ein Hattrick gelang und sein Team am Ende Platz drei belegte. In 80 Spielen für sein Land erzielte er 24 Treffer. In Italien trainierte er unter anderem US Lecce und AS Bari; von 1999 bis 2002 war Boniek Vizepräsident des Polnischen Fußballverbands (PZPN). Kurzzeitig war er während dieser Zeit auch als Coach für die polnische Nationalmannschaft verantwortlich. Im Oktober 2012 wurde er zum  PZPN-Präsidenten gewählt. Auf dem UEFA-Kongress in Helsinki im April 2017 wurde er ins UEFA-Exekutivkomitee gewählt. In diesem Interview mit UEFA Direct spricht Zbigniew Boniek über Fußball: seine Karriere als Fußballer, seine Ansichten über das Spiel, seinen Schritt von einer Fußballikone zu jemandem, der dem Fußball seines Landes als Mann an der Verbandsspitze etwas zurückgibt.  Ja, aber unter Ausschluss der Öffentlichkeit zu spielen, gehört nicht zu meinen schönsten Erinnerungen. In Polen fanden die Spiele nach der Wiederaufnahme des Spielbetriebs zuerst ohne Zuschauer statt. Ab Mitte Juni waren sie dann wieder für die Öffentlichkeit zugänglich, wobei die Kapazität der Stadien auf 25 % begrenzt war. Seit Ende Juli dürfen die Ränge bis zu maximal 50 % gefüllt werden.  Zbigniew Boniek, wie ist Polen, genauer gesagt der polnische Fußball, mit der COVID-19-Krise umgegangen? Es war natürlich ein Schock für alle, und wir durchlebten schwierige Zeiten. Da das öffentliche Leben jedoch sofort eingeschränkt wurde, überstanden wir die Periode recht gut. Zweifelsohne hat der Fußball darunter gelitten, aber wir waren froh, dass wir relativ schnell wieder spielen konnten.  Kommen wir zu Ihrem Leben im Fußball … Waren Sie schon als Kind ein Fan? Ja, ich war schon immer ein großer Fußballfan und habe mir alles gern angesehen. Ich habe immer auf der Straße Fußball gespielt. Eine meiner ersten klaren Erinnerungen an den Fußball ist, dass ich im Alter von sieben Jahren ein Spiel der zweiten polnischen Liga sah, in dem mein Vater spielte.  In ganz Europa werden Fußball­ spiele derzeit vorsichtshalber unter Ausschluss der Öffentlichkeit ausgetragen. Haben Sie als Profi je vor leeren Rängen gespielt?  Als junger Spieler war Zbigniew Boniek ein großer Bewunderer von Günter Netzer (hier bei der WM 1974, die das DFB-Team gewann).  Hatten Sie als Kind einen Lieblingsspieler? Als ich klein war, bewunderte ich den großartigen polnischen Stürmer Włodzimierz Lubański. Als ich älter wurde, habe ich vor allem den deutschen Mittelfeldspieler Günter Netzer bewundert. Als ich selber zu spielen begann, hatte ich eigentlich keine Idole mehr. Sie können auf eine großartige Karriere als Spieler auf höchstem Niveau zurückblicken. Worin lagen Ihre Stärken als Spieler? Über sich selbst zu sprechen, ist immer schwierig, aber ich glaube, ich hatte eine gute Karriere. Als Spieler war ich ein"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "UEFA  INTERVIEW  UEFA DIRECT • Q4 2020 – 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 22-quote\" style=\"top:150px; left:66px;\" src=\"/192/de/static/_content/22-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "INTERVIEW  „Allrounder“. Mehr möchte ich dazu eigentlich nicht sagen. Fragen Sie lieber meine damaligen Gegenspieler – die haben sicher mehr zu sagen!  UEFA  „Aber ich kann sagen, dass ich glücklich bin, den Polnischen Fußballverband seit acht Jahren zu führen – denn dank meiner Arbeit und der Arbeit der Menschen, die mit mir zusammenarbeiten, haben wir den Fußball in Polen verändert und verbessert .“  Was hätten Sie in Ihrem Leben getan, wenn Sie nicht Fußballer geworden wären? Ich habe meinen Abschluss in Sportwissenschaften gemacht, bevor ich Polen verließ. Ich denke, ich hätte Sportlehrer oder Trainer werden können. Auf jeden Fall hätte ich wohl etwas im Bereich Sport und Fußball gemacht. Erinnern Sie sich an ein besonders denkwürdiges Spiel? Ja, da gibt es mehrere. Ganz sicher das Spiel um Platz 3 gegen Frankreich in Alicante bei der WM 1982, das Polen mit 3:2 gewann – und, leider aus anderen Gründen, die Katastrophe im Heysel-Stadion beim Finale des Pokals der Meistervereine 1985 in Brüssel. Und haben Sie ein Lieblingstor, das Sie geschossen haben? Ich würde sagen, die zwei Tore, die ich für Juventus im UEFA-Superpokal-Spiel 1984 gegen Liverpool erzielte.  Der beste Spieler, gegen den ich gespielt habe, war Diego Maradona, der in Italien bei Neapel unter Vertrag stand.  Wer ist der beste Spieler, mit und gegen den Sie gespielt haben? Der beste Spieler, mit dem ich zusammen gespielt habe, war Michel Platini während unserer gemeinsamen Zeit bei Juventus.  Wie sehr hat sich der Fußball seit Ihrer Aktivzeit verändert? Sehr stark, denn die Regeln haben sich geändert. Wenn der Verteidiger zu meiner Zeit beispielsweise einen Spieler, der aufs Tor  22 – UEFA DIRECT • Viertes Quartal 2020  Getty Images  Wie wichtig ist Talent für den Erfolg? Und harte Arbeit? Ich glaube, Talent ist wichtig, aber oft ist es eher ein Hindernis als eine Hilfe; die Spieler werden verhätschelt und auf Händen getragen. Das Geld fängt sehr früh an zu fließen. Das kann dazu führen, dass Talent verschwendet wird. Der ideale Spieler ist ein Spieler, der zwar Talent hat, aber vor allem sehr hart an sich arbeitet.  Boniek mit Phil Neal bei der Superpokal-Partie 1984 gegen Liverpool, in der der JuventusSpieler beide Tore der Partie erzielte.  zuzog, stoppte, wurde er nicht bestraft. Das Spiel ist auch viel schneller geworden, und zwischen Mittelfeld und Verteidigung findet das Spiel auf sehr engem Raum statt. Es macht keinen Sinn, einen Vergleich anzustellen – aber ich würde sagen, wenn meine damalige Juventus-Mannschaft gegen eine heutige Mannschaft antreten würde, müssten wir uns nicht verstecken."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INTERVIEW  Hat es Ihnen in Ihrer Rolle als PZPN-Präsident geholfen, ein bekannter Spieler und ein polnisches Idol zu sein? Hat man Ihnen automa­ tisch Respekt entgegengebracht? Oder mussten Sie sich diesen Respekt erst wieder verdienen? Eine ruhmreiche Vergangenheit zu haben, hilft. Wenn man anklopft, wird einem die Tür geöffnet. Ist die Tür aber erst einmal offen, muss man zeigen, dass man etwas zu bieten hat, ansonsten ist die Vergangenheit keinen Pfifferling wert. Präsident Ihres eigenen Fußballver­ bands zu sein, muss eine erfüllende und spannende Position sein. Welche Eigenschaften muss ein Präsident mitbringen, um erfolg­ reich zu sein? Man muss den Fußball verstehen, wissen, wie man viele Leute führt, wissen, wie man sich zu verhalten und mit anderen Menschen umzugehen hat. Dies sind nur einige wenige Faktoren, die einem helfen, ein guter Präsident zu sein. Wie wichtig ist die Hilfe der UEFA für Polen, insbesondere im Rahmen des HatTrick-Programms?  Ich kann der UEFA nur danken, denn sie hat uns die Möglichkeit gegeben, in den letzten acht bis zehn Jahren unglaublich viele Veranstaltungen zu organisieren. Dank dem HatTrick-Programm konnten wir auch den Breiten- und den Juniorenfußball weiterentwickeln.  Der größte Erfolg des Polen im Nationaltrikot war der dritte Platz bei der WM 1982.  Wenn Sie einen Fußballwunsch für die Zukunft äußern könnten, wie lautet er? Noch einmal 20-jährig zu sein und am Beginn meiner Karriere zu stehen!  Wie stolz sind Sie darauf, als Mitglied des UEFA-Exekutivkomi­ tees zur Entwicklung der UEFA beizutragen? Ich freue mich wirklich sehr, Mitglied des Exekutivkomitees zu sein, und ich versuche immer, etwas vorzuschlagen, weil ich auf diesem Gebiet sehr viel Erfahrung mitbringe. Im Exekutivkomitee sitzen tatkräftige Fachleute; ich fühle mich wohl und arbeite gerne mit ihnen zusammen.  Polen hat sich für die nächste EM qualifiziert. Was ist Ihre Meinung zu Robert Lewandowski und zum aktuellen Kader? Werden sie beim Turnier im nächsten Jahr weit kommen? In Italien gibt es ein Sprichwort: „Langsam und stetig gewinnt man das Rennen.“ Ich ziehe es vor, die Leute mit meiner Nationalmannschaft zu überraschen, anstatt über die Rolle des besten Spielers zu sprechen. Nichtsdestotrotz ist es eine starke, eine sehr fähige Mannschaft, und Lewandowski ist ein Ausnahmekönner.  Was erachten Sie heute als größte Gefahr für den Fußball? Es gibt keine einfache Antwort. Vielleicht sind die Kosten für den Betrieb eines Klubs zu hoch – und dies könnte die Kluft zwischen den großen europäischen Klubs und anderen Klubs vergrößern.  Welchen Rat würden Sie einem Jungen geben, der von einer Karriere als Fußballer träumt? Dass er so lange wie möglich Spaß hat und den Fußball nicht als Lebenslösung betrachtet. Man muss es einfach Tag für Tag genießen. Und wenn man wirklich gut ist, wer weiß …  Getty Images  Wie sind Sie in die Fußballadminist­ ration gekommen? Hätten Sie sich im Laufe Ihrer Spielerkarriere je vorstellen können, eines Tages an der Spitze des Polnischen Fußball­ verbands zu stehen? Nun, wenn man jung ist, denkt man nicht wirklich über solche Dinge nach! Aber ich kann sagen, dass ich glücklich bin, den Polnischen Fußballverband seit acht Jahren zu führen – denn dank meiner Arbeit und der Arbeit der Menschen, die mit mir zusammenarbeiten, haben wir den Fußball in Polen verändert und verbessert.  Getty Images  Sie haben Polen verlassen, um im Ausland zu spielen, und mit Juven­ tus haben Sie sich in Italien einen Namen gemacht. Wie hat Ihnen diese Erfahrung geholfen, als Spieler und Person zu wachsen? Als ich zu Juventus kam, war ich bereits ein gereifter Spieler. Trotzdem habe ich noch viel dazugelernt, und ich glaube, meine Mannschaftskameraden haben ebenfalls viel von mir gelernt. Ich bin auch als Person gewachsen, wobei ich darauf vorbereitet war und nie Schwierigkeiten bekundete.  Bei der WM 1982 war Boniek einer der auffälligsten Spieler."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title\" style=\"top:131px; left:56px;\" src=\"/192/de/static/_content/24-title-1.png\">\n        <img class=\"halfScale 24-sub\" style=\"top:247px; left:58px;\" src=\"/192/de/static/_content/24-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:332px;left:308px;width:294px;height:380px;\">\n        <a href=\"https://editorial.uefa.com/resources/0261-10556abc5df0-d5da90ab290e-1000/uefa_tfyi_report_2020_5_.pdf\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"24-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ENTWICKLUNG  TRAININGSEINRICHTUNGEN UND NACHWUCHSFÖRDERUNG IN EUROPA Mit Solidaritätszahlungen in Höhe von über einer Milliarde Euro hat die UEFA im vergangenen Jahrzehnt zu den Nachwuchsförderbudgets der Vereine beigetragen. Ein gerade herausgekommener Bericht bietet einzigartige Einblicke in die strategische Verwendung dieser Gelder durch die Klubs im Hinblick auf die langfristige Entwicklung und Nachhaltigkeit.  D  ie UEFA hat einen interaktiven Bericht veröffentlicht, der exklusive Erkenntnisse zu Investitionen in Trainingseinrichtungen und die Nachwuchsförderung in ganz Europa bietet. Während der Fußball angesichts der COVID19-Pandemie in finanzieller Hinsicht unsicheren Zeiten entgegensieht, kommt einer erstklassigen Juniorenförderung und der Investition in die zur Spielerentwicklung erforderliche Infrastruktur wohl eine bedeutendere Rolle zu als je zuvor. Der Bericht zur Situation der Trainingseinrichtungen und der Nachwuchsförderung in Europa (Titel: „UEFA Training Facility and Youth Investment Landscape“; nur auf Englisch erhältlich) bietet einen umfassenden Überblick über 950 Trainingseinrichtungen von 673 europäischen Fußballvereinen auf der Grundlage von Daten, die das vergangene Jahr hindurch vom UEFA-Kompetenzzentrum erhoben wurden. Daneben finden sich Informationen zur Juniorenförderung und zu den Investitionen der europäischen Erstligisten in ihre Nachwuchssparte, die unter anderem durch die Solidaritätszahlungen der UEFA mitfinanziert werden, sowie eine nach Ländern geordnete Übersicht, die für Klubs, Medien und Fans gleichermaßen interessant sein dürfte. Die wichtigsten Ergebnisse • Die jährlichen Ausgaben der europäischen Erstligisten für die Nachwuchsförderung belaufen sich im Jahr 2020 auf geschätzte EUR 870 Mio. • Die Solidaritätszahlungen für die Juniorenförderung zugunsten von nicht an den UEFA-Wettbewerben teilnehmenden Vereinen betrugen in den letzten zehn Jahren insgesamt über eine Milliarde Euro; der jährliche Betrag hat sich innerhalb eines Jahrzehnts mehr als verdreifacht, von EUR 43 Mio. in der Saison 2008/09 auf EUR 139 Mio. in der Spielzeit 2018/19. • 1 629 verschiedene Vereine haben in diesem Zeitraum Mittel aus dem UEFA-Solidaritätsfonds erhalten.  24 – UEFA DIRECT • Viertes Quartal 2020  • 53 Erstligisten aus insgesamt 33 Ländern haben in den vergangenen zwei Jahren neue Trainingszentren eröffnet; mindestens 27 weitere Anlagen befinden sich derzeit im Bau. • In den letzten fünf Jahren haben europäische Erstligaklubs über eine Milliarde Euro in Trainingseinrichtungen investiert. • 76 % der Vereine, die über eine Frauenmannschaft verfügen, benutzen für diese dieselben Einrichtungen wie für ihr Männerteam."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:360px;top:193px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 1629, \"comma\": true}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:486px;top:193px; font-size: 1.26em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 1, \"append\": \" Mrd.\", \"preppend\": \"> EUR \"}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:362px;top:349px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 76, \"append\": \" %\"}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:549px;top:349px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 53, \"append\": \"\"}' ></h1>\n\n        <div class=\"abs\" style=\"bottom:98px;left:341px;height:268px;width:300px;overflow:hidden\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:0px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-1.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:30px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-2.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:56px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-3.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:84px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-4.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:112px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-5.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:140px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-6.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:168px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-7.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:196px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-8.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:224px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-9.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:252px;transform-origin:bottom left\" src=\"/192/de/static/_content/25-bar-10.png\">\n        </div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg25Anim = new TimelineMax();\n        pg25Anim.fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0]);}}, 1)\n        .fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1]);}}, \"+=0.3\")\n        .fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2]);}}, \"+=0.3\")\n        .fromTo(cOf(\"25-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[3]);}}, \"+=0.3\")\n        .staggerFromTo(cOf(\"25-bar\"), 1, {y: \"100%\"}, {y: \"0%\", ease: Power2.easeOut}, 0.1, \"+=0.3\")\n      }\n\n      function onPageLeave() {\n        pg25Anim.stop()\n        removeContentLinks()\n        resetNumbers(\"25-no\")\n      }\n      ",
    "searchText": "ENTWICKLUNG  DIE WICHTIGSTEN ERGEBNISSE FC FC  In den letzten fünf Jahren haben europäische Erstligaklubs über eine Milliarde Euro in Trainingseinrichtungen investiert.  FC FC  76 %  53  der Vereine, die über eine Frauenmannschaft verfügen, benutzen für diese dieselben Einrichtungen wie für ihr Männerteam.  Erstligisten aus insgesamt 33 Ländern haben in den vergangenen zwei Jahren neue Trainingszentren eröffnet; mindestens 27 weitere Anlagen befinden sich derzeit im Bau.  EUR 1,7 Mio.  EUR 1,8 Mio.  EUR 1,9 Mio.  EUR 2,7 Mio.  EUR 2,8 Mio.  EUR 3,4 Mio.  EUR 4,6 Mio.  FC Die besagten Vereine investieren derzeit insgesamt EUR 870 Mio. pro Jahr in die FC Nachwuchsförderung. Am höchsten liegen die durchschnittlichen Ausgaben eines Klubs in den folgenden zehn Ländern:  EUR 4,7 Mio.  Große regionale Unterschiede Der Bericht wirft auch ein Schlaglicht auf die von Verband zu Verband unterschiedliche Verwendung der Mittel. So kommt auf finnischen, schwedischen, norwegischen und russischen Trainingsplätzen aufgrund der klimatischen Verhältnisse häufig Kunst- oder Hybridrasen zum Einsatz, während dänische Klubs im Durchschnitt die meisten Trainingsplätze besitzen, was daran liegt, dass in dem nordischen Land bei allen Erstligisten enge Verbindungen zwischen der Breitenfußballsparte und der ersten Mannschaft bestehen. Und während jeder Klub in den letzten fünf Jahren durchschnittlich EUR 2 Mio. jährlich in Trainingsanlagen investiert hat, sind es in Deutschland, der Schweiz, Spanien und Ungarn gar jeweils über EUR 5 Mio. Dies zeigt, wie sehr die Vereine auf langfristige Entwicklung und Nachhaltigkeit setzen. So haben in Bosnien-Herzegowina und Dänemark, auf den Färöer-Inseln, in Finnland, Island, Kroatien, Schottland und Ungarn sämtliche Vereine der höchsten Spielklasse in den letzten zehn Jahren ihre Trainingsinfrastruktur verbessert.  > EUR 1 Mrd.  FC  EUR 5,3 Mio.  Solidaritätszahlungen für Nachwuchsförderung in Klubs Die UEFA-Solidaritätszahlungen für Vereine, die nicht an den UEFA-Klubwettbewerben teilnehmen, stellen die zweitgrößte Finanzierungsquelle für Trainingszentren und Juniorenförderung dar. Die Zahlungen, die Nachwuchsförderprogrammen und lokalen Projekten zugutekommen, machen geschätzt 19 % der für die Juniorenförderung der europäischen Erstligavereine verfügbaren Mittel aus.  1 629  verschiedene Vereine haben in diesem Zeitraum Mittel aus dem UEFA-Solidaritätsfonds erhalten.  EUR 6,1 Mio.  Erhöhung der Standards Zu den vorrangigen Aufgaben der UEFA als europäischer Fußballverband gehört die Anhebung der Standards auf und neben dem Spielfeld. Trainingseinrichtungen und Nachwuchsakademien bilden einen der Kernpunkte des europäischen Fußballs und haben im Zuge der COVID19-Pandemie noch an Bedeutung gewonnen. Durch die Erhöhung der Anforderungen im Bereich FC Trainingsinfrastruktur im UEFA-Reglement zur Klublizenzierung und zum finanziellen Fairplay 2018 wurde der Wert dieser beiden Komponenten nochmals unterstrichen. Der vorliegende Bericht bietet einen Überblick über die Situation in ganz Europa, wobei die Bedürfnisse und Ressourcen sich in den einzelnen Nationalverbänden sehr unterschiedlich gestalten.  UEFA DIRECT • Viertes Quartal 2020 – 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 26-title\" style=\"top:497px; left:58px;\" src=\"/192/de/static/_content/26-title-1.png\">\n        <img class=\"halfScale 26-sub\" style=\"top:576px; left:58px;\" src=\"/192/de/static/_content/26-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:152px;left:54px;width:87px;height:44px;\">\n          <a href=\"http://www.uefatechnicalreports.com/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"26-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "THE TECHNICIAN  VON TRAINERN FÜR TRAINER In den letzten 25 Jahren hat die UEFA über 130 technische Berichte über ihre Klub- und Nationalmannschaftswettbewerbe veröffentlicht. Ihr Inhalt basiert auf den Beobachtungen von Spitzentrainern, die als technische Beobachter der UEFA im Einsatz stehen. Dabei ist eine Sammlung an technischen und taktischen Analysen entstanden, die faszinierende Einblicke in die Entwicklung des europäischen Fußballs im letzten Vierteljahrhundert ermöglicht."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 27-quote\" style=\"top:674px; left:469px;\" src=\"/192/de/static/_content/27-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  N  icht allen dürfte die Rolle der technischen Beobachter auf Anhieb klar sein. Während man sich etwa über die Arbeit von Schiedsrichterbeobachtern ein klares Bild machen kann, ist die Bezeichnung „technischer Beobachter“ oder gar „technischer Bericht“ mit Fragezeichen verbunden. Eine prägnante Definition der Aufgabe der technischen Beobachter wäre „Analyse des Geschehens aus Sicht des Trainers“, wobei die Tätigkeit mittlerweile über taktische Analysen hinausgeht und auch die Wahl der besten Spieler und Mannschaften, der schönsten Tore sowie in den beiden großen Klubwettbewerben des Tors der Woche beinhaltet. Nachdem zuvor jeweils Mitglieder der technischen Kommission Artikel zu den Turnierberichten beitrugen, ging es mit den technischen Berichten bei der EM-Endrunde 1996 in England richtig los, als die UEFA mit einem Team aus fünf Beobachtern über Coaching-Themen berichtete: Gérard Houllier, Daniel Jeandupeux, Rinus Michels, Tommy Svensson und Roy Hodgson. Der ehemalige Nationaltrainer der Schweiz und Englands und aktuelle Coach von Crystal Palace erinnert sich: „Wir waren eine gute Gruppe und haben den Job sehr ernst genommen. Wir haben versucht, die wichtigsten Themen herauszupicken und das Geschehen einzuordnen. An dieser Tätigkeit hat sich im Laufe der Jahre nicht viel geändert. Es geht immer noch darum, einen technischen Bericht zu erstellen und Beobachtungen an Personen weiterzugeben, die das Turnier vielleicht nicht aus nächster Nähe verfolgt haben oder nicht über denselben Wissensstand verfügen. In aller Bescheidenheit denke ich sagen zu  dürfen, dass es uns gelungen ist, analytische Informationen und nützliche Einblicke zu liefern. Ich hielt das für eine sehr, sehr positive Sache.“ Wie sehr sich das Spiel weiterentwickelt hat, lässt sich anhand eines Beispiels aufzeigen: Bei der ersten EM-Endrunde mit 16 Teilnehmern spielte die Hälfte der Mannschaften mit Manndeckung und Libero. Wie darauffolgenden technischen Berichten zu entnehmen ist, wird die Rolle des Liberos heute weitgehend von den Torhütern übernommen, deren Ballbehandlung mit den Füßen stetig besser geworden ist, auch im Nachwuchsbereich. So ist im technischen Bericht zur U21-EM-Endrunde 2015 zu lesen, dass der deutsche Torwart Marc André ter Stegen in zahlreichen Partien mehr Pässe spielte als all seine Teamkollegen. Erfolgsrezepte „Im Laufe der Jahre“, so Hodgson, „wurde versucht, in den technischen Berichten die Aspekte hervorzuheben, die den Mannschaften zum Erfolg verholfen haben. Die athletischen Qualitäten haben sich weiterentwickelt; bei den Spielsystemen gab es Phasen mit 4-4-2 und solche mit Dreierabwehr. Die Berichte, insbesondere diejenigen zur EM-Endrunde, zur Champions League und zur Europa League, sind zudem nützliche Diskussionsgrundlagen für das Elitetrainerforum oder die Konferenz der Nationaltrainer – zahlreiche Ideen wurden in die Tat umgesetzt. Was ich auch noch betonen möchte, ist die Tatsache, dass sich die finanzielle und die Marketingseite des Fußballs rasant entwickelten, die technische Seite jedoch zu wenig herausstach. Die technischen Berichte sind insofern positiv, als sie das Spiel aus Sicht des Trainers beleuchten.“  Sportsfile  Shutterstock  „Es geht darum, einen technischen Bericht zu erstellen und Beobachtungen an Personen weiterzugeben, die das Turnier vielleicht nicht aus nächster Nähe verfolgt haben oder nicht über denselben Wissensstand verfügen.“ Roy Hodgson Ehemaliger Nationaltrainer der Schweiz und Englands  UEFA DIRECT • Viertes Quartal 2020 – 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 28-quote\" style=\"top:225px; left:382px;\" src=\"/192/de/static/_content/28-quote-1.png\">\n        <img class=\"halfScale 28-quote\" style=\"top:469px; left:86px;\" src=\"/192/de/static/_content/28-quote-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.staggerFromTo(cOf(\"28-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  „Das Schönste daran ist, dass man viele Themen mit einer Gruppe von Fußballfachleuten mit unterschiedlichen Meinungen und Sichtweisen besprechen kann.“  Sportsfile  Getty Images  David Moyes Technischer Beobachter der UEFA  „Das Beobachten von UEFA-Juniorenendrunden hat dazu beigetragen, neue Trends zu erkennen, vielversprechende Talente zu verfolgen und Parallelen zum Elitefußball zu ziehen.“ John Peacock Technischer Beobachter der UEFA  „Es braucht kein Adlerauge, um zu erkennen, dass sich alle unsere technischen Berichte auf Nationalmannschaften beziehen. Dann stellten wir fest, dass es falsch wäre, dem bedeutendsten Klubwettberb Europas keine Beachtung zu schenken.“ So äußerte sich UEFA-Präsident Lennart Johansson im Vorwort des ersten technischen Berichts zur UEFA Champions League 1998/99, die mit dem legendären Sieg von Manchester United über Bayern München in Barcelona endete. Im ersten Jahrzehnt des neuen Jahrtausends wurde auch zunehmend über die immer populäreren Juniorenwettbewerbe berichtet, und auch zur UEFA Europa League 28 – UEFA DIRECT • Viertes Quartal 2020  wurden Berichte herausgegeben, nachdem diese den UEFA-Pokal abgelöst hatte. Mittlerweile stehen bei sämtlichen Klub- und Nationalmannschaftswettbewerben der UEFA technische Beobachter im Einsatz. Bei den Klubwettbewerben gestaltet sich die Berichterstattung etwas schwieriger, da die technischen Beobachter überall auf dem Kontinent verteilt sind, wo sie einzelne Spiele analysieren, und ihre Kollegen erst beim Endspiel treffen. Entsprechend komplizierter ist das Zusammentragen der Informationen und die Erkennung von Trends. Bei Endrunden hingegen können sich die Beobachter täglich untereinander  austauschen – was sie auch zu schätzen wissen. David Moyes, der bei der EURO 2016, der UEFA Nations League und bei Champions-League-Spielen als technischer Beobachter im Einsatz stand, sagt dazu: „Das Schönste daran ist, dass man viele Themen mit einer Gruppe von Fußballfachleuten mit unterschiedlichen Meinungen und Sichtweisen besprechen kann. Ein beliebtes Diskussionsthema sind etwa auf der verkehrten Seite agierende Flügelspieler und ihr Einfluss aus das Angriffsspiel. Dieser Austausch ist wirklich gut, ich für meinen Teil habe Informationen und Ideen von der EM-Endrunde und der Nations League beigesteuert und auch welche mitgenommen. Ich denke, dass die Ideen, die man durch die Beobachtung der Coaching-Arbeit auf Topniveau erhält, bis zum Juniorenfußball hinunter umgesetzt werden können.“ Von der Spitze in die Breite Die Weitergabe von Informationen aus dem Spitzenfußball ist der Hauptzweck der technischen Berichte. John Peacock, Europameistertrainer der englischen U17Auswahl und regelmäßiger technischer Beobachter der UEFA, bestätigt dies: „Ich hatte das Glück, Juniorennationalteams zu betreuen und die Trainerausbildung in England zu leiten. Dabei empfand ich die Tätigkeit als technischer Beobachter stets als nützliche Ergänzung. Man gewinnt neue Erkenntnisse und kann das Gelernte in beiden Bereichen anwenden. Das Beobachten von UEFA-Juniorenendrunden hat dazu beigetragen, neue Trends zu erkennen, vielversprechende Talente zu verfolgen und Parallelen zum Elitefußball zu ziehen."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 29-quote\" style=\"top:299px; left:278px;\" src=\"/192/de/static/_content/29-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n        }\n      ",
    "searchText": "Zudem sind Endrunden anders – eine Mannschaft für mehrere Spiele innerhalb kurzer Zeit zu leiten ist eine Wissenschaft für sich. Ich mag es zu beobachten, wie Teams und Trainer mit dieser Herausforderung umgehen, und ob sie mehr Wert auf die Ergebnisse oder auf den Entwicklungsgedanken legen, indem sie jungen Spielern Gelegenheiten geben, sich unter Druck zu beweisen. Wenn wir den Bogen zur Trainerausbildung spannen, deckt eine Endrunde sämtliche Aspekte in technisch/taktischer, physischer, psychologischer und sozialer Hinsicht ab – alles Faktoren, die für einen erstklassigen Spieler oder Trainer ausschlaggebend sind.“ In schnell wachsenden Bereichen wie dem Frauenfußball oder dem Futsal kommt der Weitergabe von Erkenntnissen durch technische Berichte eine möglicherweise noch größere Bedeutung zu. Die langjährige technische Beobachterin Anna Signeul aus Schweden, die den schottischen Frauen mit der Women’s EURO 2017 zu ihrer ersten großen Turnierteilnahme verhalf und derzeit die finnische Frauennationalelf betreut, hält die technischen Berichte aus vielerlei Gründen für wichtig. „Sie dienen  UEFA  THE TECHNICIAN  „Für Beobachter ist eine EM-Endrunde eine riesige Lernerfahrung, und die auf zwölf Teams erweiterte Women’s EURO 2013 stellte aus meiner Sicht einen großen Fortschritt dar.“ Anna Signeul Nationaltrainerin Finnlands  als historische Aufzeichnung von Trends mit Blick auf künftige Entwicklungen. Sie sind ein Lernmittel für sämtliche Personen, die auf A- und Nachwuchsebene im Fußball tätig sind, und sie dienen Ausbildungszwecken, indem sie Analysen und Debatten auslösen und weitere Investitionen anregen. Für Beobachter ist eine EM-Endrunde eine riesige Lernerfahrung, und die auf zwölf Teams erweiterte Women’s EURO 2013 stellte aus meiner Sicht einen großen Fortschritt dar.“ Ins gleiche Horn stößt „Rekordbeobachter“ Jarmo Matikainen aus Finnland, der für die UEFA Männer- und Frauenwettbewerbe analysiert, wenn er nicht gerade mit den Nationalmannschaften von Finnland, Wales, Kanada oder aktuell Estland unterwegs ist. „Das Wachstum und die Entwicklung dieses Wettbewerbs mitzuerleben, war inspirierend, und unsere Beobachtergruppe hatte eine sehr innovative Denkweise. Wir waren immer bestrebt, die technischen Berichte besser und für alle Trainer nützlicher zu machen.“ Hope Powell, Vizeeuropameisterin mit England 2009 und ebenfalls regelmäßige technische Beobachterin, merkt an: „Ich würde sagen, dass die Berichte zur Entwicklung des Frauenfußballs beigetragen haben,  Mit der Einführung der Tracking-Technologie in der UEFA Champions League wurden bereits 2006 neue Maßstäbe gesetzt. Die Technologie basiert auf zwei Reihen von Kameras, die hoch oben auf den Tribünen installiert sind. Heute ist daraus eine hochmoderne Bildverarbeitungstechnologie geworden. Bei einer hochauflösenden Datenrate von 25 Punkten pro Sekunde erlaubt sie es, die Bewegungen der Spieler, der Schiedsrichter und des Balls in Echtzeit zu erfassen und zu verfolgen. Dadurch stehen Leistungsdaten wie Laufstrecke, Geschwindigkeit, Beschleunigung, Ausdauer, Spielsysteme und Standardsituationen umgehend für situative Videoanalysen und Grafiken zur Verfügung. All das wertet die technischen Berichte maßgeblich auf.  Bei anderen Wettbewerben wie etwa Junioren- und Juniorinnenturnieren werden die Eindrücke der technischen Beobachter von einem Analystentrio unterstützt bzw. mitgeprägt. Die drei Analysten erfassen die Spieldaten mithilfe einer maßgeschneiderten Software, die LiveVideosequenzen mit einer Spielfeldgrafik überlagert. Eine Person ist jeweils für ein Team zuständig, während die dritte Person als Datenprüfer fungiert. Mithilfe von Tastenkombinationen und Mausklicks verfolgen sie den ballführenden Spieler und  Sportsfile  Von Kugelschreibern zu Tablets  den Spielverlauf, wobei jedes Spiel zwischen 1 600 und 2 000 Datenpunkte liefert. Für die technischen Beobachter hat sich die Spielberichterstattung grundlegend verändert: Kugelschreiber und Notizblöcke sind Tablets und Tagging-Apps gewichen. Letztere ermöglichen es dem Beobachter, sich elektronisch Notizen zum Spiel zu machen und Schlüsselmomente zu markieren. Nach dem Spiel werden die Tags mit dem Video synchronisiert.  So können die Beobachter die Tags oder Videoclips ansehen, währenddessen sie ihren Spielbericht schreiben. Um Schlüsselmomente zu markieren, können auch Smartphones oder Smartwatches eingesetzt werden. Außerdem hat der heutige Beobachter Zugang zu einer taktischen Sicht auf das Spiel – dank einer Weitwinkelaufnahme, die den Blick auf die Mannschaftsaufstellungen und die taktischen Muster freigibt.  UEFA UEFA DIRECT DIRECT • Viertes • March/April Quartal 2020 – 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 30-quote\" style=\"top:159px; left:59px;\" src=\"/192/de/static/_content/30-quote-1.png\">\n        <img class=\"halfScale 30-quote\" style=\"top:647px; left:442px;\" src=\"/192/de/static/_content/30-quote-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  damit Trainer und Spieler nachvollziehen können, wie individuelle Qualitäten das Spiel einer Mannschaft – mit und ohne Ball – beeinflussen können. Die technischen Berichte haben sich in eine positive Richtung entwickelt, und die Statistiken sind ein nützliches Mittel, um Entwicklungen festzuhalten. Und die Möglichkeit, Analysen mit Videoclips visuell zu unterlegen, ist natürlich auch ein bedeutender Fortschritt.“  „Wir haben versucht, so viele Informationen wie möglich zu vermitteln. Mein Wunsch wäre es, noch mehr visuelles Material verwenden zu können, um wichtige taktische Punkte mit Illustrationen oder Animationen darzustellen.“  Didaktische Funktion Jorge Braz, amtierender Europameistertrainer der portugiesischen FutsalNationalmannschaft, sieht das ähnlich: „Die technischen Berichte der UEFA sind wichtige Referenzdokumente für die Analyse der großen Wettbewerbe und dienen dazu, aktuelle Trends und Entwicklungen im Futsal zu verstehen. Sie werden von Trainern erstellt, die über enorme Erfahrung verfügen und wissen, welche Informationen am nützlichsten sind. Die Berichte, visuellen Darstellungen und eingehenden Analysen zu den besten Teams Europas sind für junge Trainer sehr wertvoll und haben eine didaktische Funktion. Für mich und meinen Betreuerstab ist es Pflicht, über die Philosophien der Trainer der größten Nationalmannschaften Europas auf dem Laufenden zu sein und alle Details zu analysieren.“ Sein Vorgänger Orlando Duarte war einer der technischen Beobachter bei der Futsal EURO 2018: „Es war ein fantastisches Erlebnis in Sachen Kameradschaft und Lernerfahrung. Wir haben versucht, so viele Informationen wie möglich zu vermitteln. Mein Wunsch wäre es, noch mehr visuelles Material verwenden zu können, um wichtige taktische Punkte mit Illustrationen oder Animationen darzustellen.“ Beim norwegischen Nationalcoach Lars Lagerbäck, der Island bei der EURO 2016 bis 30 – UEFA DIRECT • Viertes Quartal 2020  ins Viertelfinale führte, tönt es ähnlich. „Es ist immer positiv und nützlich, eine Gesamtsicht zu erhalten und die Trends einer Endrunde zu erfahren, vor allem was die Entwicklung der Spielsysteme und die Spielphilosophien betrifft (Ballbesitz, Raumdeckung usw.). Analysen und Schlussfolgerungen sollten sich in meinen Augen stets nach der Frage richten, wie man Fußballspiele gewinnt. Das ist für mich im Hinblick auf die Ausbildung von Trainern und Spielern entscheidend. Wichtig ist, dass man versucht, die Spielweise der Teams zu analysieren,  „Die technischen Berichte haben sich in eine positive Richtung entwickelt, und die Statistiken sind ein nützliches Mittel, um Entwicklungen festzuhalten. Und die Möglichkeit, Analysen mit Videoclips visuell zu unterlegen, ist natürlich auch ein bedeutender Fortschritt.“ UEFA  und ich hoffe, dass sowohl angehende als auch erfahrene Coaches dadurch nützliche Einblicke erhalten, die mit Blick auf die Trainerausbildung weitergegeben werden können. Als Beobachterin überlege ich ständig, wie ich in bestimmten Situationen handeln würde – das ist eine echte Herausforderung!“  Sportsfile  Orlando Duarte Technischer Beobachter bei der Futsal EURO 2018  Neue Hilfsmittel Lagerbäcks Worte entsprechen genau den Vorstellungen der UEFA. Seit jeher wurde versucht, die Berichte der Beobachter statistisch zu untermauern, doch waren die verfügbaren Zahlen anfänglich zu elementar. Auch scheiterte das Vorhaben, die technischen Berichte auszubauen, bisweilen an grundlegenden Dingen wie unzureichendem Bildmaterial von Juniorenturnieren. „Dennoch haben sich die technischen Berichte auf bemerkenswerte Weise entwickelt“, bilanziert Jarmo Matikainen. „Die Verbände, für die ich tätig war, haben sie auf verschiedenartige Weise für die Trainerausbildung, die Förderung der Spieler und die Entwicklung der Vereine und des gesamten Fußballs genutzt. Die Hilfsmittel für Beobachtungen, Analysen und Darstellungen haben sich weiterentwickelt, wodurch die Berichte vielfältiger werden. Wir haben mehr Material zur Verfügung, doch am wichtigsten sind immer noch die Themenwahl und redaktionellen Prozesse.“ Die Nationalverbände wurden bei der UEFA-Konferenz zur Trainerausbildung im Herbst 2017 in Belfast zur Nützlichkeit  Lars Lagerbäck Nationalcoach Norwegens"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  UEFA  Die technischen Beobachter beim EuropaLeague-Finale zwischen Marseille und Atlético Madrid am 16. Mai 2018 in Lyon (von links nach rechts): Milenko Ačimovič, Jerzy Engel, Mixu Paatelainen, Thomas Schaaf, Ghenadie Scurtul, Stefan Majewski und Frank K. Ludolph (Leiter Fußballausbildung der UEFA).  der technischen Berichte befragt und antworteten mit einem Vertrauensvotum von 82 von 100 möglichen Punkten. Ein optimales Ergebnis – eine sehr positive Bewertung, die dennoch Spielraum für Verbesserungen lässt. Ein schwedischer Vertreter betonte zum Beispiel, wie wichtig es sei, „den Inhalt in angepasster Form in unseren Fortgeschrittenenkursen verwenden zu können. Die technischen Berichte der UEFA sind zusammen mit unseren eigenen Analysen ein bedeutender und sehr geschätzter Teil unserer Arbeit mit Trainerausbildern.“ Es gab auch geradezu enthusiastische Stimmen: „Vielen Dank an die UEFA! Grundlegende Erkenntnisse zum modernen Fußball sind für die Entwicklung des Spiels in Georgien von entscheidender Bedeutung.“ Ein kroatischer Vertreter lobte die Berichte als ausgezeichnete Möglichkeit, auf dem neusten Stand der UEFA-Spitzenwettbewerbe zu bleiben, während ein slowakischer Kollege den Nutzen der Berichte für die Trainerausbildung in allen Nationalverbänden hervorstrich und insbesondere das digitale Format schätzte. Eigene Website Seit dieser Umfrage hat sich Einiges getan. Auf der Website uefatechnicalreports.com wird momentan eine Sammlung der technischen Berichte angelegt. Das für die Berichte verantwortliche Team in Nyon wurde um einen spezialisierten Spielanalysten ergänzt. Und neben den üblichen Analysen  über Spielsysteme, die Entstehung von Toren, ruhende Bälle, Torwartleistungen, Konterspiel, die Rolle der Außenverteidiger, „falschfüßige“ Flügelspieler usw. werden in den technischen Berichten nunmehr auch Spielszenen visuell dargestellt, die aus Sicht der Beobachter für die Trainerausbildung interessant sein könnten. Gleichzeitig steht auch die technologische Entwicklung nicht still – das macht sich die UEFA zunutze, indem sie die Statistikteile ihrer Berichte aufpeppt und Videolinks einfügt, um technische und taktische Aussagen zu veranschaulichen. Die technischen Beobachter beginnen nun Tablets und Apps zu nutzen, mit denen sie potenziell erwähnenswerte Spielsituationen sofort festhalten können. Nach den Spielen können sie auf mehrere Kamerawinkel zugreifen und Aufnahmen der TV-Übertragung sowie der Taktikund Hintertorkameras in ihre Berichte einfließen lassen. Dank topmodernen Visualisierungstools können Overlay-Grafiken in diese Clips eingefügt werden, um taktische Analysen zu verdeutlichen. Zurück im Hotel – oder bereits auf dem Weg dorthin – können die Beobachter ihre selber kreierten Clips und die während des Spiels erfassten Daten sichten, darunter die Anzahl Pässe, Schüsse und Flanken oder anspruchsvollere Daten zu Spielerinnen und Spielern wie zurückgelegte Distanz, maximale Geschwindigkeit oder durchschnittliche Position auf dem Spielfeld. Solches Datenmaterial kann besonders dann nützlich sein, wenn etwa die Spielweise  der Flügelpositionen näher untersucht werden soll. Bei einem Turnier mit mehreren Spielen pro Tag wie der auf nächstes Jahr verschobenen UEFA EURO 2020 wird dank des schnellen Zugangs zu Videos und Daten mehr Zeit für taktische Analysen, Diskussionen und die Suche nach Trends im Vergleich zu früheren Ausgaben übrig bleiben. Dadurch können die Beobachter der Trainergilde ein vollständigeres Bild vermitteln und gleichzeitig kann das Material zur Aufwertung von Trainerausbildungskursen genutzt werden. „Ich bin in der zweiten Hälfte der 1990er-Jahre erstmals mit den technischen Berichten der UEFA in Berührung gekommen“, erinnert sich Jarmo Matikainen. „Das war zu Beginn des Internet-Zeitalters, als es für angehende Trainer schwieriger war, Zugang zu Informationen über internationale Trends zu erhalten. Die UEFA-Berichte erwiesen sich als sehr nützlich und haben das Trainerwesen auf eine völlig neue Ebene befördert. Seither ist viel Zeit vergangen und die Anforderungen haben sich verändert, doch es ist immer noch wichtig, dass Toptrainer ihr Wissen und ihre Erfahrung weitergeben und Nationalverbänden und Trainern vermitteln, worauf es im sehr fordernden Umfeld des Fußballs ankommt. Zwar sind die technischen Berichte nun online zugänglich und das Begleitmaterial hat sich quantitativ und qualitativ verbessert, doch die Einblicke und Impulse, die Traineraspiranten und Trainerausbilder daraus ziehen können, sind immer noch genau dieselben.“ UEFA DIRECT • Viertes Quartal 2020 – 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 32-title\" style=\"top:132px; left:208px;\" src=\"/192/de/static/_content/32-title-1.png\">\n        <img class=\"halfScale 32-sub\" style=\"top:284px; left:58px;\" src=\"/192/de/static/_content/32-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.fromTo(cOf(\"32-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"32-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n      ",
    "searchText": "R. Jurković  FORSCHUNGSSTIPENDIEN-PROGRAMM  „DIE BEDEUTUNG DES FUSSBALLS FÜR FLÜCHTLINGE UND ASYLSUCHENDE“  Für ihr Projekt „Fußball und Flüchtlinge: kulturelle Anthropologie des Balkan-Korridors“ erhielt Dr. Rahela Jurković eines von sechs UEFA-Forschungsstipendien für die Saison 2019/20.  N  achdem sie die Ergebnisse ihrer Forschungsarbeiten der Jury des UEFA-ForschungsstipendienProgramms vorgestellt hatte, sprach Dr. Jurković mit UEFA Direct über die Bedeutung des Fußballs für Flüchtlinge und Asylsuchende in Kroatien, BosnienHerzegowina, Griechenland, Nordmaze­ donien und Serbien.  genau, wie ich Migranten finden sollte, die Fußball spielen. Ein wichtiger Ansprechpartner, in der kulturellen Anthropologie auch „Gatekeeper“ genannt, half mir – woraufhin ich mehr Migranten fand, als ich für meine Arbeit benötigt hätte. Insgesamt befragte ich in diesen fünf Ländern 71 Flüchtlinge und 13 Personen, die im Bereich Flüchtlinge und Fußball arbeiten.  Was hat Sie dazu bewegt, auf diesem Gebiet zu forschen? Der erste Beweggrund war die Tatsache, dass ich für meine Doktorarbeit über die Integration von Flüchtlingen in die kroatische Gesellschaft herausgefunden hatte, dass Fußball ein Weg zur Integration von Menschen ist und dass viele Flüchtlinge in Kroatien Fußball spielen. Der zweite Beweggrund war, dass in den Jahren 2015 und 2016 über 600 000 Flüchtlinge und Asylsuchende durch den „Balkan-Korridor“ reisten, weshalb ich auf die Idee kam, in diesen Länder zu forschen. In meinem Fachgebiet, der kulturellen Anthropologie, wurde Sport bisher kaum untersucht. Trotzdem erhielt ich Unterstützung vom Kroatischen Fußballverband, der mir vorschlug, auch andere Länder in meine Forschungsarbeiten mit einzubeziehen.  Haben diese Interviews Ihre Erwartungen bestätigt? Oder gab es auch Überraschungen? Ich war überrascht. In Griechenland, wo es viel mehr Flüchtlinge und Asylsuchende gibt als in Kroatien, sah ich Flüchtlinge, die dreimal am Tag Fußball spielen. Angeblich haben einige von ihnen sogar bei Spitzenklubs trainiert. Ebenfalls erstaunt war ich darüber, dass es für sie sehr schwierig war, sich bei lokalen Klubs anzumelden. Die Registrierung erfolgt jeweils durch die Nationalverbände, aber ich habe gehört, dass zwischen 2015 und Oktober 2019, als wir die Interviews führten, nur vier Flüchtlinge bei lokalen Teams in Griechenland gemeldet waren. Ich sprach mit vielen Flüchtlingen, die sich registrieren lassen wollten. Sie spielten für ihr Leben gern Fußball, waren aber unglücklich darüber, dass sie ihr Talent nicht auf dem Platz zeigen konnten.  fünf Ländern arbeiten, darunter der FC Hope Refugee und der FC Hestia in Athen. Hestia ist der einzige Frauenfußballklub in der Region. In Thessaloniki gibt es die Initiative „Football for All“ (Fußball für alle) und die Organisation „Arsis“. In Belgrad war ich bei Nichtregierungsorganisationen wie „Info Park“ und dem „ADRA Community Centre“. In Kroatien traf ich Mazen, einen Mann, der eine informelle Gruppe von Menschen organisiert, die Flüchtlingen über den Fußball helfen. Sie alle brauchen jedoch Unterstützung. Ein Team wie der FC Hope Refugee, der vom Internationalen Olympischen Friedenszentrum in Athen betrieben wird, braucht Geld, um arbeiten zu können. Wenn Sie wollen, dass etwas für Flüchtlinge funktioniert, brauchen Sie Menschen, die für ihre Arbeit bezahlt werden. Diese arbeiten unabhängig von den Nationalverbänden mit Geldern aus verschiedenen Quellen, aber jedes Jahr müssen sie sich nach sechs Monaten jeweils Zeit nehmen, um neue Mittel zu finden. Ich hoffe, meine Forschungsarbeiten zeigen, dass Organisationen, die hinter Fußballmannschaften wie Hope Refugee und Hestia stehen, ernsthaft und mit engagierten Menschen arbeiten. Sie sind Vorbilder, und ich würde mir wünschen, dass sie von größeren Fußballverbänden in ihrer Arbeit unterstützt würden.  War es für Sie positiv zu sehen, dass die Flüchtlinge von verschiedenen Organisationen unterstützt werden? Natürlich. Eine meiner Empfehlungen an die UEFA und den Fußball im Allgemeinen lautet, Organisationen zu unterstützen, die versuchen, auf diese Weise mehr Menschen zu erreichen. In meinem Bericht sind einige Organisationen erwähnt, die in den  Hat Sie Ihre Forschung eher optimistisch oder pessimistisch gestimmt? Eher optimistisch. Ich habe viele talentierte Menschen getroffen, die zeigen wollen, dass sie durch den Fußball etwas bewirken können. Es sind Menschen, die wissen, wie man sich organisiert, und die gezeigt haben, dass man auch ohne Ausrüstung Fußball spielen kann. Niemand hat etwas  Wie schwierig war die konkrete Feldarbeit? Die Forschungszeit betrug acht Monate. Zwischen September 2019 und April 2020 musste ich fünf Länder abdecken. Unterstützt wurde ich teilweise von Dolmetschern bzw. Kulturmittlern, aber den Löwenanteil der Arbeit leistete ich selbst. In Griechenland hatte ich lediglich einen oder zwei Ansprechpartner. Als Erstes war ich in Thessaloniki und wusste nicht 32 – UEFA DIRECT • Viertes Quartal 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "FORSCHUNGSSTIPENDIEN-PROGRAMM  Hestia FC  für sie organisiert – sie haben es selbst in die Hand genommen. In Athen traf ich eine fast 40-jährige Iranerin, die den Fußball für sich entdeckt hat. Das war großartig für mich, räumt es doch mit dem Vorurteil auf, Frauen sollten nur spielen, wenn sie jung sind. Ich hörte Geschichten von Frauen, die im Iran mit Hidschab Fußball gespielt haben, und sie sagten, es sei viel besser, ohne ihn zu spielen. Beim FC Hestia spielen auch Frauen aus Afghanistan. Alle erzählten sie mir, wie der Fußball ihnen geholfen habe, Depressionen und andere psychische Probleme zu überwinden. Eine Frau weinte, nachdem sie darüber gesprochen hatte, wie ihr  Leben vor dem Beitritt zu diesem Frauenfußballklub ausgesehen hatte. Am Ende weinten wir alle. Was erhoffen Sie sich von Ihrer Forschung? Ich hoffe, sie hilft mit, das Bewusstsein dafür zu schärfen, dass Flüchtlinge in Südosteuropa Fußball spielen. Einige von ihnen verbringen bis zu vier Jahre in Lagern, und sie spielen Fußball. Deshalb brauchen sie Ausrüstung und organisierte Trainingseinheiten. Mein Vorschlag an die Nationalverbände und lokalen Fußballklubs ist, dass sie sich an die Flüchtlingszentren wenden und dort fragen, ob sie helfen  können. Ich hoffe auch, dass ich Beispiele positiver Praktiken angeführt habe – und aufgezeigt habe, dass diese Organisationen langfristig unterstützt werden sollten. Wichtig ist zudem die Frage der Registrierung in lokalen Vereinen und inwiefern die nationalen Bestimmungen geändert werden können, um Asylsuchenden die Registrierung zu ermöglichen, wie es das FIFA-Reglement grundsätzlich vorsieht. Ein Befragter in Athen sagte mir: „Man darf mit Asylpapieren arbeiten, aber nicht Fußball spielen. Wie kommt das? Wie kann man jemandem das Recht auf Arbeit, nicht aber das Recht aufs Fußballspielen geben?“  Durch den Fußball möchte der Athener Verein Hestia FC Migrantinnen ins gesellschaftliche Leben integrieren.  UEFA DIRECT • Viertes Quartal 2020 – 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 34-title\" style=\"top:125px; left:58px;\" src=\"/192/de/static/_content/34-title-1.png\">\n        <img class=\"halfScale 34-sub\" style=\"top:249px; left:58px;\" src=\"/192/de/static/_content/34-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"34-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "UEFA GROW  UEFA-GROW-UNTERSTÜTZUNG FÜR VERBÄNDE DANK NEUER FINANZMANAGEMENT-SÄULE In diesen unsicheren Zeiten ist die finanzielle Lage der Mitgliedsverbände angespannter denn je. Deshalb hat die UEFA im Rahmen von Grow jüngst einen Grundlagenkurs zu Verbandsfinanzen angeboten und Treffen mit Finanzdirektoren von Verbänden in ganz Europa organisiert.  Getty Images  „  D  as Ziel ist nicht, dass Sie am Ende dieses Seminars alle Finanzexperten sein müssen, es ist wichtiger, dass Sie die Grundlagen kennen, insbesondere die wichtigsten Kennzahlen im Jahresabschluss und in der Finanzplanung ihres Nationalverbands, um die richtigen Fragen zu stellen“, erklärte Josef Koller den Teilnehmern zum Auftakt des ersten Webinars des dreiteiligen Kurses im September. Vorrangig ging es bei der Fortbildung darum, Vorstandsmitgliedern, Generalsekre-  tären und weiteren Verbandsverantwortlichen ein besseres Verständnis von Finanzkennzahlen und Rechnungslegung zu vermitteln, die in Zeiten der COVID19-Pandemie unverzichtbar sind, um fundierte strategische Entscheidungen treffen zu können. Organisiert war der Kurs, ein wesentlicher Teil der neuen FinanzmanagementSäule von UEFA Grow, in Form von drei interaktiven Lunch-Sitzungen. Daneben fand eine Reihe regionaler Treffen von  Finanzdirektoren aus zahlreichen Ecken Europas statt, angefangen mit einer Zusammenkunft der Vertreter der nordischen Verbände Ende Mai. Good Governance und finanzielle Nachhaltigkeit gehören zu den Kernpunkten der GrowStrategie, und die UEFA nutzt diese Art von Treffen, um herauszufinden, mit welchen besonderen Herausforderungen die Nationalverbände in dieser beispiellosen Zeit konfrontiert sind, und um bewährte Vorgehensweisen zu teilen.  Der Portugiesische Fußballverband, der den amtierenden Europameister und Nations-League-Gewinner stellt, nahm ebenfalls am ersten UEFA-Grow-Webinar zu finanziellen Fragen teil."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 35-quote\" style=\"top:143px; left:454px;\" src=\"/192/de/static/_content/35-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.fromTo(cOf(\"35-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n        }\n      ",
    "searchText": "UEFA GROW  „Finanzen sind ein Schlüsselbereich in jeglicher Organisation mit Geschäftstätigkeit. Es ist wichtig, dass die UEFA das Wohlergehen sämtlicher Nationalverbände sicherstellt.” Josef Koller UEFA-Finanzdirektor  UEFA  Lage der einzelnen Verbände und die besonderen Herausforderungen, welche die Pandemie in bestimmten Regionen mit sich gebracht hat, besser nachzuvollziehen.  Finanzielle Grundlagen vermitteln Das Grow-Team stellte den Finanzgrundlagenkurs mit Unterstützung und Beratung von Francesc Solanellas, Professor für Sportmanagement am Nationalen Institut für Sportpädagogik und Sportwissenschaften Kataloniens (INEFC), auf die Beine. Die UEFA Academy, die UEFA-Division Finanzen und die Finanzdirektoren der UEFA-Mitgliedsverbände leisteten ebenfalls Beiträge. Besprochen wurde, dass das Verbandspersonal nicht selten alle finanziellen Fragen den einschlägigen Experten überlässt, da dieser Bereich als sehr komplex empfunden wird. Im neuen Kurs brachten Finanzdirektoren von Mitgliedsverbänden aus ganz Europa Fallstudien ein, anhand derer die Teilnehmer und insbesondere diejenigen Funktionäre, die bisher nicht mit dieser Materie vertraut waren, sich grundlegende Kenntnisse im Finanzwesen aneignen konnten. Jeder Nationalverband konnte bis zu vier gewählte oder ernannte Führungskräfte (Exekutivkomiteemitglieder, den Präsidenten, den Generalsekretär oder dessen Stellvertreter) zum Kurs anmelden. Rund 150 Teilnehmer schalteten sich so am 9. September zu dem ersten zweistündigen Webinar mit Josef Koller zusammen, auf dessen Programm eine von Prof. Solanellas gehaltene „Einführung in Finanzwesen, Finanzberichte und Audits“ stand, gefolgt von Fallstudien aus Portugal und Tschechien. Jeder Redner stellte sich einer Fragerunde und das Feedback war insgesamt sehr positiv – 96 % der Teilnehmenden gaben an, „sehr zufrieden“ mit dem Webinar gewesen zu sein.  Im zweiten Kursteil eine Woche später ging es dann um das Thema „Finanzierung der Verbandsstrategie, Budget und Prognosen“, während bei der dritten und letzten Einheit am 30. September „Finanzielles Risikomanagement und aktuelle finanzielle Herausforderungen für Nationalverbände“ im Mittelpunkt standen. Sämtliche Webinare wurden aufgezeichnet, sodass sie problemlos mit dem Exekutivkomitee oder den Mitarbeitenden eines Verbands sowie den angeschlossenen Regionalverbänden geteilt werden können, um das wertvolle Wissen weiter zu verbreiten. „Die Fakten hinter den Zahlen“ Zur Bedeutung der Seminare sagte Josef Koller: „Finanzen sind ein Schlüsselbereich in jeglicher Organisation mit Geschäftstätigkeit , daher freue ich mich zu sehen, dass so viele Verantwortliche aus den Nationalverbänden Interesse daran haben, sich solide Grundkenntnisse im Finanzwesen anzueignen, um die Fakten hinter den Zahlen leichter erkennen und fundiertere Entscheidungen in finanziellen Fragen treffen zu können.“ Regionale Treffen mit Finanzdirektoren Parallel zu dem Finanzgrundlagenkurs fanden im letzten Quartal diverse Sitzungen mit Finanzdirektoren aus verschiedenen Länderregionen statt – eine Gelegenheit für die Führungskräfte, sich untereinander kennenzulernen und enger in die strategische Planung der UEFA eingebunden zu werden. Für das UEFA-Grow-Team bot sich derweil die Chance, die aktuelle finanzielle  Zum Auftakt der Norden Bei der ersten Zusammenkunft der nordischen Länder am 21. Mai mit Dänemark, den Färöer-Inseln, Island, Norwegen und Schweden standen die Bewertung des Finanzprofils der einzelnen Verbände und eine Diskussion über die Auswirkungen von COVID-19 und die ergriffenen Maßnahmen auf dem Programm. Einen Monat später, am 23. Juni, waren Finanzdirektoren aus englischsprachigen Ländern – Schottland, England, Nordirland, Wales und der Republik Irland – an der Reihe, bevor am 14. August mit Belgien, Deutschland, Frankreich, den Niederlanden, Portugal und Spanien die WesteuropaGruppe folgte. Austausch und Wissenstransfer Nach diesem Treffen sagte Ron Francis, der Finanzdirektor des Niederländischen Fußballverbands: „Es ist das allererste Mal, dass sich die Finanzdirektoren der Region Westeuropa getroffen haben. Diese großartige Initiative von UEFA Grow, die Finanzdirektoren untereinander zu vernetzen, hat es uns ermöglicht, uns auszutauschen und unser Wissen zum Nutzen des europäischen Fußballs zu teilen.“ Bei der letzten Sitzung am 18. September kamen die Mitteleuropäer aus Italien, Österreich, Polen, der Schweiz, der Slowakei, Tschechien und Ungarn zusammen. Als Nächstes sind Treffen der östlichen und südlichen Regionen geplant, und das Grow-Team arbeitet intensiv daran, schlussendlich den Finanzdirektoren aller europäischen Nationalverbände diese Möglichkeit zu bieten. UEFA DIRECT • Viertes Quartal 2020 – 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 36-title\" style=\"top:84px; left:59px;\" src=\"/192/de/static/_content/36-title-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        }\n        function onPageLeave() {\n          pg36Anim.stop();\n        }\n      ",
    "searchText": "WETTBEWERBE  FRAUEN-, FUTSAL- UND JUNIOR­EN­ WETTBEWERBE VERSCHOBEN  U  m die Nationalverbände von zusätzlichem organisatorischen und finanziellen Aufwand – aufgrund der Hygienevorschriften für Reisen und Unterkünfte sowie der Testungen zum Schutz der Spielerinnen und Spieler – zu entlasten und das potenzielle Risiko weiterer Ansteckungen möglichst gering zu halten, hat das UEFA-Exekutivkomitee am 13. August und am 15. September folgende Beschlüsse zu den UEFA-Frauen-, -Futsal- und -Juniorenwettbewerben gefasst:  Wettbewerbe 2019/20  U17-Frauen-Europameisterschaft • Absage der Eliterunde und der Endrunde • Falls die FIFA-U17-Frauen-Weltmeisterschaft stattfindet, nehmen die drei europäischen Mannschaften mit dem höchsten Koeffizienten daran teil (Deutschland, England und Spanien, in alphabetischer Reihenfolge).  UEFA  U19-Europameisterschaft • Die Eliterunde wird auf November 2020 verschoben (anstatt Oktober 2020) und das Finalturnier wird im März 2021 in Nordirland ausgetragen. • Das Format des Finalturniers wurde angepasst und besteht nun aus einer einfachen K.-o.-Phase mit Viertelfinale, Halbfinale und Endspiel (sowie den Playoff-Begegnungen zur Qualifikation einer fünften Mannschaft für die U20-Weltmeisterschaft 2021).  36 – UEFA DIRECT • Viertes Quartal 2020  Wettbewerbe 2020/21  • • • •  U17-Frauen-Europameisterschaft Austragung der Qualifikationsrunde bis Ende Februar 2021 (12 Miniturniere) Eliterunde wird gestrichen und durch Playoffs ersetzt Playoffs mit 14 Mannschaften bis Ende März 2021 Endrunde wie ursprünglich vorgesehen (Mai 2021 auf den Färöer-Inseln)  U17-Europameisterschaft • Austragung der Qualifikationsrunde bis Ende März 2021 (13 Miniturniere) • Eliterunde gestrichen • 13 Gruppensieger und zwei gesetzte Mannschaften qualifizieren sich für die Endrunde, die wie ursprünglich vorgesehen stattfindet (Mai 2021 in Zypern)  • • • •  U19-Frauen-Europameisterschaft Qualifikationsrunde im Februar 2021 (12 Miniturniere) Eliterunde wird gestrichen und durch Playoffs ersetzt Playoffs mit 14 Mannschaften im April 2021 Endrunde wie ursprünglich vorgesehen (Juli 2021 in Belarus)  • • • •  U19-Europameisterschaft Qualifikationsrunde im März 2021 (13 Miniturniere) Eliterunde wird gestrichen und durch Playoffs ersetzt Austragung der Playoffs mit 14 Mannschaften bis Ende Mai 2021 Endrunde wie ursprünglich vorgesehen (Juli 2021 in Rumänien)  UEFA Women’s Champions League • Die Miniturniere der Vorrunde werden durch zwei K.-o.-Runden mit Spielen, die in jeweils einer einzigen Begegnung stattfinden, ersetzt. Die erste Qualifikationsrunde mit 40 Mannschaften wird am 3./4. November ausgetragen, die zweite Qualifikationsrunde am 18./19. November mit 20 Mannschaften. • Das Sechzehntelfinale wird auf den 8./9. Dezember und 15./16. Dezember verschoben. • Die übrigen Spiele des Wettbewerbs werden wie ursprünglich geplant ausgetragen: • Achtel- und Viertelfinale im März 2021 • Halbfinale im April 2021 • Endspiel im Mai 2021  UEFA Futsal Champions League • Vorrunde, Hauptrunde und Eliterunde (alle ursprünglich als Miniturniere geplant) werden durch K.-o.-Runden mit Spielen, die in jeweils einer einzigen Begegnung stattfinden, ersetzt. Die Vorrunde wird im November 2020, das Sechzehntelfinale im Januar 2021 und das Achtelfinale im Februar 2021 ausgetragen. • Das Finalturnier wird mit acht Mannschaften (anstelle von vier Mannschaften) im April oder Mai 2021 stattfinden."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 37-title\" style=\"top:129px; left:211px;\" src=\"/192/de/static/_content/37-title-1.png\">\n        <img class=\"halfScale 37-sub\" style=\"top:211px; left:211px;\" src=\"/192/de/static/_content/37-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim.fromTo(cOf(\"37-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"37-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg37Anim.stop();\n        }\n      ",
    "searchText": "GIBRALTAR  NEUES LOGO ZUM RUNDEN JUBILÄUM In diesem Jahr feiert der Fußballverband von Gibraltar sein 125-jähriges Bestehen. Aufgrund der COVID-19-Pandemie und ihrer direkten Auswirkungen auf seine Mitglieder konnte der Verband das für dieses historische Ereignis vorgesehene Veranstaltungsprogramm leider nicht wie geplant durchführen. VON STEVEN GONZALEZ  2018, beim ersten Länderspiel als UEFAund FIFA-Mitglied im Victoria Stadium, bat Nationaltrainer Julio Ribas seine Spieler und seinen Stab, sich beim Singen der Nationalhymne mit dem Gesicht zum Felsen zu drehen. Inzwischen ist das für die Nationalmannschaften – und die Fans – Gibraltars zu einem wichtigen Ritual vor Heimspielen geworden. Das neue Verbandslogo setzt auf ein modernes, abstraktes Design: Mithilfe zweier vertikal ausgerichteter Winkelzeichen bzw. Pfeilspitzen zeichnet es den Felsen von Gibraltar so nach, wie man ihn vom Victoria Stadium aus sieht. Die beiden Winkel symbolisieren das Alte und das Neue. Im neuen Jahrzehnt steht die GFA vor frischen Herausforderungen – Herausforderungen, denen sie sich als Bannerträgerin und Verantwortliche des gibraltarischen Fußballs stellen will. Dabei darf der Verband aber die gesamte Arbeit der letzten 125 Jahre nicht vergessen, in denen der Fußball für das Wachstum und die Entwicklung dieser wunderbaren Nation eine enorm wichtige Rolle gespielt hat.  GFA-Generalsekretär Ivan Robba sagte: „Das neue Logo ist ein Schlüsselelement in der Weiterentwicklung des Fußballverbands von Gibraltar in einen modernen und professionellen Sportverband. Unsere Absicht war klar: Wir wollten eine einzigartige und aussagekräftige neue Identität, die im Einklang mit den globalen Fußballtrends steht, aber gleichzeitig die zentralen Werte und Prinzipien des Verbands widerspiegelt. Das symbolträchtige Bild des Felsens von Gibraltar, der über das Victoria Stadium wacht, hat jahrzehntelang Generationen gibraltarischer Fußballer inspiriert, und je weiter dieses Konzept entwickelt wurde, desto klarer wurde, dass dies im Mittelpunkt unserer neuen Identität stehen musste. Die beiden nach oben gerichteten Winkel auf dem Logo widerspiegeln den Aufbruch der GFA in eine neue Ära, ohne die hervorragende Arbeit zu vergessen, die von allen Beteiligten seit der Gründung des Verbands im Jahr 1895 geleistet wurde. Von nun an werden gibraltarische Fußballnationalmannschaften überall dort, wo sie ein Spielfeld betreten, den Felsen von Gibraltar auf der Brust tragen.“  Getty Images  T  rotz COVID-19 war es wichtig, dieses wegweisende Jahr mit einer bedeutenden Änderung zu würdigen – und zwar rechtzeitig zum Start von Gibraltars Nations-League-Kampagne im Victoria-Stadion. In enger Zusammenarbeit mit dem UEFA-Grow-Programm, in dessen Rahmen sich die UEFA-Mitgliedsverbände für die Zukunft rüsten sollen, hat der Fußballverband von Gibraltar (GFA) ein umfassendes Projekt zur Neugestaltung seines Logos und seiner visuellen Identität in Angriff genommen. Den Grundstein, sowohl für die Designarbeit als auch für das gesamte Erscheinungsbild des neuen Logos, legten die Recherchen der UEFA-Branchenexperten, die das bisherige Logo genau unter die Lupe nahmen. Bei der Vorstudie und den Recherchen zum neuen Logo brachte der Verband klar zum Ausdruck, dass er den neuen visuellen Schwerpunkt seines Logos eng mit den Symbolen der Nation verflochten sehen möchte und dass das neue Logo eine moderne, zukunftsorientierte Bild- und Verbandsidentität widerspiegeln sollte, um die GFA ins neue Jahrzehnt und in die nächste Generation zu führen. Seitdem im Victoria Stadium Fußball gespielt wird, ist vom Mittelkreis aus stets das Wahrzeichen der Nation zu sehen: der Felsen von Gibraltar. Der Fels hat Generationen von Fußballern begleitet, die Gibraltar mit Stolz erfüllt haben – von den alten Schotterplätzen in den 1950er- und 1960er-Jahren über die 1970er- und 1980er-Jahre bis hin zu den 1990er-Jahren und den ersten Kunstrasenplätzen, mit unterschiedlichsten Gastmannschaften und den unvergesslichen Sunshine Games (Inselspiele), bis hin ins neue Jahrtausend und schließlich ins moderne Zeitalter der UEFA- und FIFA-Mitgliedschaft.  UEFA DIRECT • Viertes Quartal 2020 – 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title\" style=\"top:366px; left:58px;\" src=\"/192/de/static/_content/38-title-1.png\">\n        <img class=\"halfScale 38-sub\" style=\"top:443px; left:58px;\" src=\"/192/de/static/_content/38-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(cOf(\"38-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"38-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "LITAUEN UEFA YOUTH LEAGUE  NEUE VISUELLE IDENTITÄT Im Zuge eines Markenerneuerungsprozesses haben der Litauische Fußballverband (LFF) und die litauischen Nationalmannschaften neue, separate Logos erhalten. VON AGNĖ RUDYTĖ  K  reiert wurden die Logos von der Agentur Frame in Zusammenarbeit mit Experten des UEFA-Grow-Programms. Die Aufgabe der LFF besteht darin, den Fußball in Litauen weiterzuentwickeln und zu fördern – dafür muss sie das Spiel schützen, was durch den Schild passend symbolisiert werden kann. Darüber hinaus ist das Logo so gestaltet, dass die Zugehörigkeit zum Fußballverband leicht erkennbar ist. Dazu tragen ein Fußball und die Initialen der LFF bei, die in den Schild eingebettet sind, während dazwischen der vollständige Name des Verbands aufgeführt ist, was dessen Rolle als Dachorganisation des Fußballs in Litauen unterstreicht. Da es sich um einen nationalen Verband handelt, enthält das Logo auch die litauische Landesflagge und hat damit internationalen Wiedererkennungswert. „In den letzten Jahren ist es im Verband zu zahlreichen positiven Veränderungen gekommen, da wir uns zu einer modernen Organisation entwickeln wollen. Das bisherige LFF-Logo stammte aus dem Jahr  38 – UEFA DIRECT • Viertes Quartal 2020  2009, weshalb die Zeit reif für eine Anpassung war. In enger Zusammenarbeit mit Vertretern des UEFA-Grow-Programms haben wir Pläne entwickelt, um den Verband zu modernisieren, und die Erneuerung unserer Markenidentität war Teil dieses Prozesses“, erklärt LFF-General­ sekretär Edgaras Stankevičius. Das neue Logo der Nationalmannschaften ist eine moderne Interpretation des litauischen Nationalsymbols, des weißen Ritters. Um zu einem einfachen, schnörkellosen Motiv zu gelangen, verzichteten die Designer auf die Hinterläufe des Pferdes und rückten die triumphale Pose des Ritters in den Fokus. Dabei entstand ein markantes Piktogramm, das die Form eines Ritterschilds widerspiegelt. Das Logo ist so angeordnet, dass alle Schräglinien und äußeren Kanten eine Einheit bilden – ein für litauisches Design übliches Merkmal. „Das neue Logo sieht toll aus – es ist moderner. Es verkörpert Mut und Entschlossenheit, und diese Eigenschaften sind im Fußball unglaublich wichtig“, sagte Nationalspieler Džiugas Bartkus.  In diesem Sommer hat der Litauische Fußballverband ein neues Pilotprojekt auf den Weg gebracht: Mithilfe offener Trainingseinheiten sollen mehr Frauen dazu bewegt werden, Fußball zu spielen und zu schauen. Der Anklang war enorm, als Milda Liužinaitė, Spielführerin der litauischen Nationalmannschaft, und Greta Guižauskaitė, Projektleiterin für den Bereich Spielerinnen/Breitenfußball, am 13. Juni im LFF-Stadion in Vilnius die erste vom Verband organisierte Trainingseinheit leiteten. Seitdem fanden zwei weitere Einheiten statt, die zweite davon unmittelbar vor dem LFF-Pokalfinale. Litauen hat Glück: Dank rechtzeitiger Maßnahmen zur Eindämmung der COVID-19-Pandemie können derzeit bis zu 1 000 Zuschauer bei Sportveranstaltungen dabei sein. Somit konnten alle Frauen, die an der zweiten Trainingseinheit teilgenommen hatten, im Stadion bleiben und das Pokalfinale verfolgen. Die dritte Trainingseinheit war ein weiterer großer Meilenstein, wurde sie doch vor dem ersten Spiel in der neu geschaffenen Frauen-Regionalliga durchgeführt. Diese Trainingseinheit zog auch Mütter an, deren Kinder Fußball spielen. Sie sagten, es sei eine wunderbare Möglichkeit gewesen, den Sport, den ihre Kinder über alles liebten, auszuprobieren, und hätte ihnen geholfen, sich ihnen näher zu fühlen.  LFF  LFF  Pilotprojekt soll mehr Frauen zum Fußball bringen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-title\" style=\"top:152px; left:71px;\" src=\"/192/de/static/_content/39-title-1.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:188px; left:71px;\" src=\"/192/de/static/_content/39-sub-1.png\">\n        <img class=\"halfScale 39-title\" style=\"top:384px; left:71px;\" src=\"/192/de/static/_content/39-title-2.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:449px; left:71px;\" src=\"/192/de/static/_content/39-sub-2.png\">\n        <img class=\"halfScale 39-title\" style=\"top:589px; left:71px;\" src=\"/192/de/static/_content/39-title-3.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:648px; left:71px;\" src=\"/192/de/static/_content/39-sub-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg39Anim.stop();\n        }\n      ",
    "searchText": "MEMBER MITGLIEDSVERBÄNDE ASSOCIATIONS  ALBANIEN  www.fshf.org  WIEDERAUFBAU NACH DEM ERDBEBEN ANDI VERÇANI  Der Albanische Fußballverband (FSHF) hat mit dem Wiederaufbau eines der Häuser begonnen, die durch das verheerende Erdbeben vom 26. November 2019 zerstört worden waren. Dem Beginn der Bauarbeiten wohnten FSHF-Präsident Armand Duka, MännerNationaltrainer Edoardo Reja, die Nationalspieler Elseid Hysaj und Etrit Berisha sowie Nationalspielerin Megi Doçi bei. Ermöglicht wird der Wiederaufbau zerstörter Häuser  durch die Beiträge des Verbands, der Betreuer der Nationalmannschaft, der Spieler und der Partnerverbände. Unter dem Motto „Wir sind eine Mannschaft – wir bauen gemeinsam wieder auf“ nahmen Armand Duka, Edoardo Reja und die Spieler an der symbolischen Zeremonie und Grundsteinlegung für das neue Gebäude teil. Der FSHF-Präsident dankte allen, die zu diesem Projekt beigetragen haben: „Die Pandemie hat unser  Projekt für einige Zeit unterbrochen. Nach dem tragischen Erdbeben im vergangenen November ergriffen wir alle innerhalb des Verbands – alle Nationalspieler, der Nationaltrainer, aber auch die Partnerverbände – die Initiative und eröffneten ein Konto, auf das man auch noch so kleine Beiträge für den Wiederaufbau von Häusern einzahlen konnte. Das ist das erste Haus, bei dessen Wiederaufbau wir mithelfen, drei weitere werden folgen.“  ASERBAIDSCHAN  NEUER CHEFTRAINER FÜR DIE NATIONALMANNSCHAFT  AFFA  www.affa.az Gianni de Biasi  FIRUZ ABDULLA  Die aserbaidschanische Nationalelf der Männer hat die UEFA Nations League 2020/21 unter einem neuen Cheftrainer in Angriff genommen. Der Aserbaidschanische Fußballverband und der italienische Coach Gianni de Biasi unterzeichneten am  30. Juli einen Vertrag über die künftige Zusammenarbeit. De Biasi wird Aserbaidschan im Rahmen der UEFA Nations League 2020/21 und der Qualifikation zur WM 2022 betreuen und sagte nach seiner Ernennung: „Ich freue mich, Nationaltrainer der aserbaidschanischen  Nationalmannschaft zu sein. Ich werde mein ganzes Wissen und meine Erfahrung in die Waagschale werfen, um diese Mannschaft so weit wie möglich voranzubringen und Erfolge mit ihr zu feiern.“  BELARUS  www.abff.by  NEUES NATIONALTRIKOT IN MINSK VORGESTELLT ALEXANDR ALEINIK  Der Belarussische Fußballverband hat die neue Spielkleidung seiner Nationalmannschaft präsentiert, die im Rahmen des UEFA-AusrüstungsUnterstützungsprogramms in Zusammenarbeit mit dem Ausrüster Macron entworfen wurde. Das neue Heimtrikot ist Weiß mit Rundhalsausschnitt und enthält ein traditionelles Strickmuster. Auf der Innenseite des Kragenbereichs befindet sich der Hashtag #БЕЛЫЯКРЫЛЫ (weiße Flügel), während die Rückseite des Kragens mit dem weißen Schriftzug  Мы – Беларысы (Wir sind Belarussen) bestickt ist. Ein besonderes Merkmal des Trikots ist das vertikale weiße Band mit einem landestypischen Muster, das in der Mitte des Hemdes eingeprägt ist. Die weiße Hose enthält einen gleichfarbigen Tunnelzug und rote Ränder, und auch die Stutzen sind weiß mit einem roten oberen Rand. Das neue Auswärtstrikot ist ähnlich gestaltet, allerdings mit Polokragen. Die Farbe Rot dominiert und in der Mitte ist ebenfalls ein gleichfarbiges und traditionell osteuropäisches Muster  vertikal eingeprägt. Die Innen- und die Rückseite des Kragens sind mit denselben kyrillischen Schriftzügen verziert wie das Heimtrikot. Auf beiden Hemden befindet sich das Wappen auf der linken Brust. Vervollständigt wird die Auswärtskleidung durch eine rote Hose mit weißen Tunnelzügen sowie rote Stutzen mit weißem oberem Rand. Das Torwarttrikot gibt es in drei verschiedenen Farbkombinationen: Neongrün mit schwarzen Details, Anthrazit mit neongrünen Details und Hellblau mit schwarzen Details. UEFA DIRECT • Viertes Quartal 2020 – 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:152px; left:57px;\" src=\"/192/de/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-sub\" style=\"top:211px; left:57px;\" src=\"/192/de/static/_content/40-sub-1.png\">\n        <img class=\"halfScale 40-title\" style=\"top:482px; left:57px;\" src=\"/192/de/static/_content/40-title-2.png\">\n        <img class=\"halfScale 40-sub\" style=\"top:542px; left:57px;\" src=\"/192/de/static/_content/40-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:662px;left:579px;width:138px;height:12px;\">\n          <a href=\"https://landsholdslejren.buzzsprout.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:673px;left:444px;width:138px;height:12px;\">\n          <a href=\"https://landsholdslejren.buzzsprout.com/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"40-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  BULGARIEN  www.bfunion.bg  BREITENFUSSBALLPROGRAMM MIT VIER NEUEN TRAININGSZENTREN CHRISTO SAPRJANOW  Das Trainingszentrum in Sandanski ist die vierte Einrichtung, die vom BFS mit finanzieller Unterstützung der UEFA fertiggestellt wurde. Die ersten drei  Einrichtungen befinden sich im Stadtbezirk Nadeschda der Hauptstadt Sofia sowie in den Städten Pasardschik und Silistra.  BFU  Selbst in diesen sehr ungewissen Zeiten unterstützt der Bulgarische Fußballverband (BFS) weiter den Breitenfußball im Land. Jüngst eröffneten Borislaw Popow, BFS-Generalsekretär, und Atanas Stojanow, Bürgermeister der Stadt Sandanski, offiziell eine neue hochmoderne Anlage im Südwesten des Landes. Das Trainingszentrum umfasst drei Kunstrasenplätze, auf denen Spiele der bulgarischen Mini-Fußball-Liga ausgetragen werden. „So bringen wir die zukünftigen Stars des bulgarischen Fußballs hervor. Ich bin sicher, dass die neuen Berbatows und Stoitschkows ihre ersten Schritte auf solchen Plätzen machen werden“, sagte Bürgermeister Stojanow. DÄNEMARK  www.dbu.dk  PODCAST VON DEN TRAININGSLAGERN DER NATIONALMANNSCHAFTEN MICHELLE THYGESEN  40 – UEFA DIRECT • Viertes Quartal 2020  und England am 5. bzw. 8. September gab. Die erste Sendung wurde auf verschiedenen Kanälen bereitgestellt und wurde von den Fans sehr begrüßt – alleine in den ersten 24 Stunden verzeichnete der Podcast über 2 500 Abonnenten. Seither haben sich über 10 000 Hörerinnen und Hörer zugeschaltet und so für eine Verdoppelung der Abrufe gesorgt; damit ist dieses Angebot der zweiterfolgreichste Podcast auf iTunes Dänemark in der Kategorie Sport. In einer weiteren Folge konnten die Fans mehr über die Geschichte der Jugendfreunde Mathias „Zanka“ Jørgensen und Jonas Lössl erfahren, die mittlerweile  gemeinsam für Dänemark auf dem Platz stehen. Ebenfalls geplant ist ein Beitrag mit dem Cheftrainer des Frauennationalteams, Lars Søndergaard, aus dem Trainingscamp der dänischen Nationalspielerinnen, und vieles mehr. Mehr Informationen über den Podcast finden sich unter folgendem Link: https:// landsholdslejren.buzzsprout.com/.  fodboldbilleder.dk  Spielerinnen und Spieler, Trainerinnen und Trainer und Betreuerinnen und Betreuer der dänischen Nationalmannschaften lassen sich für einen neuen Podcast einspannen, der von Fankoordinator Anders Hagen moderiert wird. Damit sollen die Fans exklusive Einblicke in die Trainingscamps erhalten in einer Zeit, in der die Öffentlichkeit keinen wirklichen Zugang zu den Nationalspielerinnen und -spielern hat. Der Podcast wurde am ersten Tag des Trainingslagers der Männernationalelf am 24. August gestartet – an jenem Tag versammelte sich das Team zum ersten Mal unter dem neuen Cheftrainer Kasper Hjulmand, der Åge Hareide abgelöst hat. In der ersten Folge erhielten die Fans Einblicke in das Schaffen des neuen Coaches, der ausführlich Auskunft über seine Überlegungen hinter dem Aufgebot für die wichtigen Nations-League-Partien gegen die Fußball-Schwergewichte Belgien"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 41-title\" style=\"top:148px; left:71px;\" src=\"/192/de/static/_content/41-title-1.png\">\n        <img class=\"halfScale 41-sub\" style=\"top:234px; left:71px;\" src=\"/192/de/static/_content/41-sub-1.png\">\n        <img class=\"halfScale 41-title\" style=\"top:564px; left:71px;\" src=\"/192/de/static/_content/41-title-2.png\">\n        <img class=\"halfScale 41-sub\" style=\"top:625px; left:71px;\" src=\"/192/de/static/_content/41-sub-2.png\">\n        <div class=\"addContentLink\" style=\"top:475px;left:590px;width:28px;height:12px;\">\n          <a href=\"//TheFA.com/HeadsUp\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:486px;left:457px;width:158px;height:12px;\">\n          <a href=\"//TheFA.com/HeadsUp\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:497px;left:457px;width:40px;height:12px;\">\n          <a href=\"//TheFA.com/HeadsUp\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:497px;left:515px;width:117px;height:12px;\">\n          <a href=\"//headstogether.org.uk/heads-up\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:509px;left:457px;width:47px;height:12px;\">\n          <a href=\"//headstogether.org.uk/heads-up\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.staggerFromTo(cOf(\"41-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"41-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg41Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  ENGLAND  www.thefa.com  POKALFINALE FÜLLT WEMBLEY MIT „KLÄNGEN DER UNTERSTÜTZUNG“ FÜR MENTALE GESUNDHEIT  FA-Cup-Finale unter Ausschluss der Öffentlichkeit statt –, stellte man die Veranstaltung unter das Motto „#SoundOfSupport“ (Klänge der Unterstützung). Während es im Wembley-Stadion still war, sprach man draußen lauter und deutlicher denn je über das Thema psychische Gesundheit. Die Fans wurden aufgefordert, „Klänge der Unterstützung“ zu zeigen und sicherzustellen, dass sie von denjenigen gehört wurden, die sie brauchen. Vor Spielanpfiff stellte man im Rahmen einer beeindruckenden #SoundOfSupportAktion eine Minute lang die „Heads  ESTLAND  www.jalgpall.ee  AUSBILDUNG NEUER SCHIEDSRICHTER CARLOS KUIV  Der Grundkurs für Schiedsrichteraspiranten des Estnischen Fußballverbands (EJL) erfreut sich großer Beliebtheit. Allein in diesem Jahr haben sich etwa 100 Aspirantinnen und Aspiranten angemeldet. Als einzige Voraussetzung müssen die Teilnehmenden mindestens 15 Jahre alt sein. Der Kurs wird gleichzeitig an vier verschiedenen Orten in Estland durchgeführt. Der erste Teil der diesjährigen Ausgabe fand Ende August statt, der zweite Teil folgt Mitte Oktober. Nach Abschluss des ersten Teils des Grundkurses können die angehenden Referees bereits Spiele in einigen Juniorenkategorien leiten und vom Verband  Up“-Kampagne in den Mittelpunkt. Im Stadion wurde künstlich eine einmalige Geräuschkulisse erzeugt, die sich aus den Bruchstücken echter Gespräche mit Fans und Spielern zum Thema psychische Gesundheit zusammensetzte. Bevor die Geräuschkulisse eingespielt wurde, hörten die Spieler und Fans ein markantes Sprechstück des Dichters und Aktivisten für psychische Gesundheit Hussain Manawer. Die Werbebotschaften für die „Heads Up“-Kampagne waren im ganzen Stadion sichtbar, so auch auf den Schleifen am Siegerpokal. Außerdem trugen sowohl die Mannschaften als auch die Schiedsrichter das Logo der Kampagne auf ihrer Spielkleidung. Weitere Informationen über die „Heads Up“-Kampagne finden sich unter www. thefa.com/about-football-association/ heads-up und www.headstogether.org.uk/ heads-up.  als Schiedsrichterassistenten auf anderen Stufen eingesetzt werden. Der EJL legt seit einigen Jahren ein größeres Augenmerk auf die Ausbildung und Betreuung von Unparteiischen. In diesem Sommer ernannte er zudem regionale Leiter des Schiedsrichterwesens, die für die Organisation und Durchführung regionaler Workshops sowie für die allgemeine Unterstützung der Schieds­ richterinnen und Schiedsrichter verantwortlich sind. Um Weltklassereferees hervorzubringen, ist es zwingend notwendig, sämtlichen interessierten Personen eine Einstiegsmöglichkeit zu bieten. Kristo Tohver, UEFA-Refe-  Brit Maria Tael-Estonian FA  Im August endete der FA Cup 2019/20 mit einem Endspiel, das dem Thema psychische Gesundheit gewidmet war. Mit Unterstützung ihres Hauptsponsors Emirates wurde die renommierte Veranstaltung in „The Heads Up FA Cup Final“ umbenannt. Das Finale bildete den Höhepunkt der Kampagne „Heads Up“ (Kopf hoch), die der Englische Fußballverband (FA) und die Stiftung „Heads Together“ die ganze Saison über beworben hatten. Die Kampagne unter der Schirmherrschaft des Herzogs von Cambridge setzte auf die Beliebtheit und Reichweite des Fußballs, um junge Menschen dazu zu bewegen, ihre mentale Gesundheit in einem für sie geeigneten Rahmen bewusst zu thematisieren und diesbezügliche Maßnahmen zu ergreifen. Angesichts der beispiellosen Umstände, die das Spiel umgaben – erstmals fand ein  TheFA  DAVID GERTY  ree der ersten Kategorie, leitete vor kurzem zwei Partien der Saudi Pro League und wurde dabei von Silver Kõiv und Sten Klaasen assistiert. Das estnische Schiedsrichtergespann konnte dabei erste Erfahrungen mit dem VSA-System sammeln. Ende August wurde FIFA-Schiedsrichterassistentin Karolin Kaivoja ihrerseits für das Halbfinale in der UEFA Women’s Champions League zwischen Paris Saint-Germain und Lyon aufgeboten. UEFA DIRECT • Viertes Quartal 2020 – 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 42-title\" style=\"top:152px; left:57px;\" src=\"/192/de/static/_content/42-title-1.png\">\n        <img class=\"halfScale 42-sub\" style=\"top:188px; left:57px;\" src=\"/192/de/static/_content/42-sub-1.png\">\n        <img class=\"halfScale 42-title\" style=\"top:400px; left:57px;\" src=\"/192/de/static/_content/42-title-2.png\">\n        <img class=\"halfScale 42-sub\" style=\"top:459px; left:57px;\" src=\"/192/de/static/_content/42-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"42-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  FÄRÖER-INSELN  www.football.fo  ENTWICKLUNGSARBEIT IM FRAUENFUSSBALL TERJI NIELSEN  Maria Ziskason Nesá  FSF  Seit langem ist der Färöische Fußballverband (FSF) bestrebt, den Frauenfußball im Land intensiver zu fördern. Vor diesem Hintergrund hat er den Posten der Leiterin Frauenfußball geschaffen und Maria Ziskason Nesá mit diesem betraut. „Marias Aufgabe besteht darin, sich um die Entwicklung des Frauenfußballs zu kümmern. Parallel dazu erarbeiten wir zurzeit eine neue Strategie für den Frauenfußball auf den Inseln, für deren  Umsetzung sie ebenfalls verantwortlich zeichnen wird“, erklärt Pætur Smith Clementsen, technischer Direktor des FSF. Im Mai nächsten Jahres richten die Färöer-Inseln die Endrunde der U17-FrauenEuropameisterschaft aus. „Unsere neue Strategie soll bis zur Endrunde stehen, damit wir sie während des Turniers vorstellen können. Und wir wollen auch, dass unsere Leiterin Frauenfußball dem Frauenfußball in unserem Land zu mehr Sichtbarkeit verhilft“, so Clementsen.  GEORGIEN  www.gff.ge  DAS WARTEN HAT EIN ENDE: FUSSBALLZENTRUM IN POTI ERÖFFNET Am 2. September wurde in Poti das neue Fußballzentrum des Georgischen Fußballverbands (GFF) mit einem Freundschaftsspiel zwischen dem Amateurverein FC Chabonama und einem GFF-Team feierlich eingeweiht. Letzteres setzte sich aus ehemaligen Spielern zusammen, die zu unterschiedlichen Zeiten aktiv waren. Vor dem Spiel richtete Verbandspräsident Lewan Kobiaschwili einige Worte an die Junioren der örtlichen Fußballschulen und die anwesenden Gäste. „Ich bin sehr stolz auf dieses Projekt. Vor einigen Jahren habe ich diesen Ort besucht und die Bedingungen gesehen, in denen die Kinder Fußball spielten. Ich freue mich für die Stadt Poti, dass sie nun etwas vorweisen kann, was ihr lange Zeit fehlte. Für die Entwicklung des Juniorenfußballs in dieser Region stellt das neue Fußballzentrum einen großen Schritt nach vorne dar. Die Anlagen werden außerdem den Amateur- und Frauenvereinen in der Gegend zur Verfügung stehen. Ich bin fest überzeugt, dass diese neue, moderne Einrichtung dazu beitragen wird, dass sich mehr Menschen im Fußball engagieren. Unser konkretes Ziel ist es, die Fußballinfrastruktur weiterzuentwickeln und den 42 – UEFA DIRECT • Viertes Quartal 2020  GFF  TATA BURDULI  Zugang zum Fußball sowie eine gesunde Lebensführung in ganz Georgien zu ermöglichen“, erklärte der GFF-Präsident. Der neue Komplex umfasst zwei Standard-Spielfelder mit Flutlichtanlagen, Umkleidekabinen, eine Tribüne und ein Verwaltungsgebäude. Der Bau des Fußballzentrums begann im Juli 2019 und  wurde durch die GFF, das UEFA-HatTrickund das FIFA-Forward-Programm mitfinanziert. Der georgische Verband ist für die Instandhaltung des Zentrums, das von Fußballschulen sowie Amateur- und Frauenvereinen kostenlos genutzt werden kann, verantwortlich."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 43-title\" style=\"top:152px; left:71px;\" src=\"/192/de/static/_content/43-title-1.png\">\n        <img class=\"halfScale 43-sub\" style=\"top:211px; left:71px;\" src=\"/192/de/static/_content/43-sub-1.png\">\n        <img class=\"halfScale 43-title\" style=\"top:573px; left:71px;\" src=\"/192/de/static/_content/43-title-2.png\">\n        <img class=\"halfScale 43-sub\" style=\"top:635px; left:71px;\" src=\"/192/de/static/_content/43-sub-2.png\">\n        <div class=\"addContentLink\" style=\"top:148px;left:53px;width:432px;height:50px;\">\n        <a href=\"https://www.figc.it/it/federazione/federazione-trasparente/reportcalcio/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.staggerFromTo(cOf(\"43-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"43-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg43Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  ITALIEN  www.figc.it  10. AUSGABE DES REPORTCALCIO VERÖFFENTLICHT DIEGO ANTENOZIO  4,6 Millionen Aktive, über 570 000 offizielle Partien, 1,4 Mio. Lizenzspielerinnen und -spieler und ein sozio­ ökonomischer Nutzen in Höhe von rund EUR 3,1 Mrd.: Diese Zahlen über den italienischen Fußball sind der 10. Ausgabe des ReportCalcio, dem statistischen Jahresbericht des italienischen Fußballs, zu entnehmen, der vom Studienzentrum des Italienischen Fußballverbands (FIGC) in Zusammenarbeit mit der AREL (Agentur für Recherche und Gesetzgebung) und der Unternehmensberatung PricewaterhouseCoopers (PwC) verfasst wurde. Mit 12 127 Vereinen und 64 827 Mannschaften ist und bleibt der Fußball die Sportart Nummer eins im Land. Der Profisektor warf im vergangenen Jahr einen Gewinn in Höhe von EUR 3,8 Mrd. ab und trug EUR 1,3 Mrd. zu den nationalen Steuer- und Sozialabgaben bei. Der ReportCalcio bietet eine umfassende Analyse verschiedener Bereiche: Neben der statistischen Erhebung zum italienischen Fußball sind auch ein Profil der NationalKROATIEN  mannschaften (in sportlicher, medialer und kommerzieller Hinsicht) sowie Analysen des Junioren- und Amateurbereichs, der wirtschaftlichen und finanziellen, organisatorischen, infrastrukturellen und steuerlichen Situation enthalten, ebenso wie ein internationaler Vergleich. Neu ist in dieser Ausgabe das Kapitel über die Fanbasis hinzugekommen. Im Profibereich ist der Gesamtumsatz in der Saison 2018/19 aufgrund höherer kommerzieller Erträge (+19,7 %) und Mehreinnahmen aus Medienrechten (+11,8 %) um 8,5 % gewachsen. Gleich­ zeitig sank der Wertzuwachs um 3,1 % – ein Zeichen dafür, dass ein Teil der Vereine sein Kerngeschäft besser ausschöpft. Die Steuer- und Sozialabgaben beliefen sich 2017 auf EUR 1,3 Mrd. (+7,4 % gegenüber 2016 und +47 % im Vergleich zu 2006). Dies hat zu einer Zunahme der Ressourcen geführt, die dem gesamten italienischen Sportsystem zugutekommt: So konnten 2019 EUR 60 Mio. mehr verteilt werden, und 2020 standen EUR 95 Mio. mehr zur  Verfügung. Pro Euro staatlicher Investitionen in den Fußball flossen EUR 16,10 an Steuer- und Sozialleistungen an die Gesellschaft zurück. Allein auf den Profifußball entfallen 71,5 % der Gesamtsteuerbeiträge des italienischen Sports. Weniger gut sieht es hingegen bei den Infrastrukturen aus – trotz einer ermutigenden Trendwende bei der Renovierung bereits vorhandener Stadien, die auch der Ausrichtung der U21-Europameisterschaft im vergangenen Sommer zu verdanken war, welche zu Investitionen in Werbung und Modernisierungsmaßnahmen in Höhe von EUR 30 Mio. geführt hat. Zwischen 2009 und 2019 entfällt im gesamteuropäischen Vergleich nur 1 % der Investitionen im Bereich Stadionneubau auf Italien; das Durchschnittsalter italienischer Arenen liegt bei 63 Jahren. Der Ausbruch der COVID19-Pandemie hat die Veränderungsprozesse in diversen Bereichen weiter beschleunigt – so mussten neue Wege der Fanbeteiligung gefunden werden und die sogenannte digitale Revolution schritt weiter voran.  www.hns-cff.hr  LUKRATIVER TV-DEAL FÜR DEN KROATISCHEN FUSSBALL Während die globale COVID19-Pandemie die Fußballvereine weltweit in finanzielle Schwierigkeiten bringt, konnten sich die kroatischen Profivereine im vergangenen August zumindest über eine positive Nachricht des Kroatischen Fußballverbands (HNS) freuen. Im Zuge einer öffentlichen Ausschreibung für Übertragungsrechte an Spielen unter Aufsicht des Verbands gab der HNS den Abschluss seines bis dato größten TV-Rechtevertrags mit dem neuen Medienpartner Endorphin Magine Ltd. bekannt. Ab der Spielzeit 2022/23 übernimmt  Endorphin die Produktion sämtlicher Spiele im HNS-Portfolio – dazu zählen die Klubwettbewerbe der Männer und Frauen, alle verfügbaren Partien des Futsal-Nationalteams, der Juniorenauswahlen und der Frauennationalelf sowie die nicht zentral vermarkteten Freundschaftsspiele der Männer-Nationalmannschaft. Dank des neuen Vertrags können die an die kroatischen Vereine ausgeschütteten Mittel um ein Vielfaches erhöht werden, und auch die gesamte kroatische Fußballgemeinde profitiert davon. „Unsere Partnerschaft mit Endorphin widerspiegelt die wachsende internationale  HNS  NIKA BAHTIJAREVIĆ  Attraktivität unserer Wettbewerbe und läutet eine neue Ära für den kroatischen Fußball ein – dieser hat in den letzten Jahren einen regelrechten Boom erlebt, sowohl dank unseren ausgezeichneten Nationalmannschaften als auch dank den Leistungen unserer Klubs. Dank ihrer harten Arbeit konnten wir das Profil unserer Wettbewerbe schärfen und einen Vertrag dieser Größenordnung unterzeichnen, sagte HNS-Präsident Davor Šuker. UEFA DIRECT • Viertes Quartal 2020 – 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 44-title\" style=\"top:147px; left:57px;\" src=\"/192/de/static/_content/44-title-1.png\">\n        <img class=\"halfScale 44-sub\" style=\"top:188px; left:57px;\" src=\"/192/de/static/_content/44-sub-1.png\">\n        <img class=\"halfScale 44-title\" style=\"top:458px; left:57px;\" src=\"/192/de/static/_content/44-title-2.png\">\n        <img class=\"halfScale 44-sub\" style=\"top:494px; left:57px;\" src=\"/192/de/static/_content/44-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.staggerFromTo(cOf(\"44-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"44-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg44Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  LETTLAND  www.lff.lv  NEUER PRÄSIDENT UND VORSTAND GEWÄHLT TOMS ĀRMANIS  LFF  Die Mitglieder des Lettischen Fußballverbands (LFF) haben einen neuen Präsidenten und Vorstand gewählt. Diese sollen die Entwicklung des lettischen Fußballs in den nächsten vier Jahren vorantreiben. Zum neuen LFF-Prä-  sidenten gewählt wurde Vadims Ļašenko; er erhielt 96 Stimmen der beim Jahreskongress des Verbands anwesenden 129 Mitglieder. Vadims Ļašenko ist im lettischen Fußball kein Unbekannter: Er stand 42 Mal in der Futsal-Nationalmannschaft, für die er lange Zeit die Kapitänsbinde tragen durfte, und gewann 7 Mal die lettische Futsal-Meisterschaft. Zu Beginn seiner Karriere war Ļašenko aktiver Schiedsrichter, später wurde er UEFA-Delegierter. Seit der Gründung des lettischen Futsal-Verbands im Jahr 2014 war er dessen Präsident. Nach seiner Wahl zum LFF-Präsidenten trat er von diesem Amt zurück. „Ich weiß, dass es für die Mitglieder der LFF wichtig ist, jemanden aus den eigenen  LIECHTENSTEIN  Reihen an der Spitze des lettischen Fußballs zu haben. Ich kenne ihre Bedürfnisse, Ideen und Schwierigkeiten sehr gut. Zusammen mit meinem Team werde ich alle auf die Zukunft einschwören und dem lettischen Fußball so den dringend benötigten neuen Schub verleihen“, sagte Ļašenko nach seiner Wahl. Der neue LFF-Vorstand besteht aus acht Mitgliedern, darunter zwei Frauen. Er bestätigte Edgars Pukinsks als LFF-Generalsekretär. Vor dem Kongress wurde Jurijs Andrejevs zum neuen LFF-Sportdirektor ernannt. Er löste Dainis Kazakevičs ab, der zum neuen Cheftrainer der lettischen Männer-Nationalmannschaft ernannt wurde. www.lfv.li  LIECHTENSTEIN ARBEITET AN NEUER VISION FLORIAN HEPBERGER  44 – UEFA DIRECT • Viertes Quartal 2020  Arbeitsgruppen die notwendigen Schritte ausgearbeitet werden. „Die Mitarbeit der Vereine ist für den Verband von großer Wichtigkeit und bietet die Grundlage für die LFV-Strategie 2021-26 mit dem Ziel einer strategischen Planung für den Fußball in Liechtenstein. Dies wird durch uns bekräftigt, indem wir die Vision ins Herz unserer Strategie stellen“, freut sich LFV-Generalsekretär Peter Jehle über die  LFV  Zusammen mit seinen sieben Mitgliedsvereinen erarbeitet der Liechtensteiner Fußballverband seine Schwerpunkte im Bereich Breiten- und Spitzenfußball für die Periode 2021-26. Unter dem Projekttitel „Vision Fussball Liechtenstein“ wurde ein umfangreicher Prozess gestartet, welcher die notwendigen Maßnahmen für eine Verbesserung des Fußballs in Liechtenstein aufzeigen soll. Im Jahr 2018 startete der Verband eine Gesprächsreihe mit seinen Mitgliedsvereinen, mit dem Ziel einer umfassenden Analyse der Ist-Situation. Diese Ergebnisse wurden in einer ersten Gesamtveranstaltung im vergangenen Jahr präsentiert. Aufgrund der weiteren Rückmeldungen der Vereine wurde der Fokus auf die vier Themenfelder Breitenfußball, Entwicklung, Spitzenfußball und Frauenfußball gelegt. In Arbeitsgruppen mit Vereins- und Verbandsvertretern wurden nun mögliche Maßnahmen erarbeitet und vor kurzem bei einer weiteren Gesamtveranstaltung präsentiert. Diese Vorschläge aus den Arbeitsgruppen wurden von den Vereinen sehr positiv aufgenommen, sodass in weiterer Folge in neuen  Zwischenergebnisse, und LFV-Präsident Hugo Quaderer zeigt sich zufrieden mit den positiven Rückmeldungen der Vereine: „Das an der Gesamtveranstaltung erzielte einvernehmliche Resultat, das von allen Vereinen mitgetragen wird, ist für uns alle die verbindliche Grundlage für die Planung und Umsetzung der nächsten Schritte. Der zweite Teil der Visionsveranstaltung hat dafür bereits erste Resultate geliefert.“"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 45-title\" style=\"top:152px; left:71px;\" src=\"/192/de/static/_content/45-title-1.png\">\n        <img class=\"halfScale 45-sub\" style=\"top:211px; left:71px;\" src=\"/192/de/static/_content/45-sub-1.png\">\n        <img class=\"halfScale 45-title\" style=\"top:494px; left:71px;\" src=\"/192/de/static/_content/45-title-2.png\">\n        <img class=\"halfScale 45-sub\" style=\"top:577px; left:71px;\" src=\"/192/de/static/_content/45-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.staggerFromTo(cOf(\"45-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"45-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg45Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  LUXEMBOURG  www.football.lu  STADE DE LUXEMBOURG WIRD ENDE 2020 BEZUGSBEREIT SEIN JOËL WOLFF  aber auch andere von der FLF ausgerichtete Partien sowie die Spiele der luxemburgischen Vereine in den europäischen Wettbewerben. Das neue Stadion ersetzt  FLF  Das neue Nationalstadion des Luxemburgischen Fußballverbands (FLF) wurde auf den Namen „Stade de Luxembourg“ getauft. Gelüftet wurde dieses Geheimnis durch Vertreter der FLF, welche die Anlagen jüngst in Begleitung der Bürgermeisterin der Stadt Luxemburg und des Sportministers besuchten. Das neue Stadion liegt im Süden der Hauptstadt Luxemburg, hat eine Kapazität von 9 386 Sitzplätzen in den Nationalfarben (rot, weiß, blau) und soll bis Ende 2020 fertiggestellt sein. Eröffnet wird das Stadion im März 2021 mit einem Qualifikationsspiel der luxemburgischen Nationalmannschaft für die Fußball-WM 2022. Im Stade de Luxembourg werden Nationalmannschaftsspiele ausgetragen, MALTA  endgültig das ehemalige Josy-BarthelStadion. Das von den Architektenbüros gmp (Deutschland) und BENG (Luxemburg) entworfene Gebäude wird einen Hybridrasenplatz, 560 VIP-Plätze, eine Flutlichtanlage mit über 1 700 Lux sowie alle von der UEFA für ein Stadion der Kategorie 4 vorgesehenen Räumlichkeiten, Umkleidekabinen, Säle, Zuschaueranlagen und Medienarbeitsplätze umfassen. Die Kosten für das neue Stadion werden sich auf 76,6 Millionen Euro belaufen, die vollständig von der Stadt und dem Staat Luxemburg finanziert werden. Die Verbandsverantwortlichen können es kaum erwarten, das neue luxemburgische Fußballjuwel endlich in Betrieb zu nehmen. wwww.mfa.com.mt  GOOD GOVERNANCE UND NACHHALTIGKEIT IM ZENTRUM LAUFENDER REFORMEN DES VERBANDS KEVIN AZZOPARDI  Der Maltesische Fußballverband (MFA) hat einen umfassenden Governance-Reformprozess in zahlreichen wichtigen Bereichen in Gang gesetzt, darunter Ethik und Integrität, Statuten, Beschaffungswesen, Klublizenzierung auf nationaler Ebene und Unternehmensrestrukturierung der Vereine. Parallel zu diesen Reformen entwickelt der Verband derzeit eine neue Vierjahresstrategie, die in den kommenden Monaten veröffentlicht werden soll. MFA-Präsident Bjorn Vassallo betont, dass die Wahrung der Nachhaltigkeit des maltesischen Fußballs im Zentrum der Reformen steht. „Nachhaltigkeit fußt auf zwei Säulen – Good Governance, basierend auf bewährten Vorgehensweisen und höheren Standards, sowie finanzielle Stabilität, die eine gute  Abstimmung zwischen Einnahmen, Ausgaben und langfristigen Investitionen erfordert.“ Die neu geschaffene Kommission für Ethik und Integrität ist hauptsächlich damit beauftragt, jegliches Verhalten zu ahnden, das der Integrität und dem Ruf des Fußballs schaden könnte; besonders im Fokus stehen dabei illegale, sittenwidrige und unethische Machenschaften. Die Kommission für die Statutenrevision hat ihrerseits die Aufgabe, mit Unterstützung von FIFA und UEFA die Statuten und Entscheidungsfindungsprozesse der MFA zu überarbeiten und zu modernisieren. Reformiert wurde auch der Status der Vereine je nach Spielklasse, wobei die Mannschaften der höchsten Ligen (Premier League und Challenge League) neu Profistatus haben dürfen, während  darunter der Amateurstatus strikt beibehalten wird. Die Fußballentwicklung spielt mit Blick auf die allgemeine Förderung des Männer- und Frauenfußballs eine entscheidende Rolle, weshalb die Ausweitung der diesbezüglichen Lizenzkriterien einen bedeutenden Schritt in der Weiterentwicklung des gesamten Lizenzierungsverfahrens darstellt. Letztlich soll die Reform für fairere Wettbewerbe, finanzielle Disziplin und langfristige Stabilität sorgen. Im Rahmen der Restrukturierung der Vereine schließlich werden die einschlägigen Regularien den Anforderungen der heutigen Zeit angepasst. Das Ziel besteht darin, die maltesischen Klubs ihrer Lizenz und ihrem Status entsprechend so zu modernisieren, dass sie Unternehmensstatus erlangen können. UEFA DIRECT • Viertes Quartal 2020 – 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 46-title\" style=\"top:152px; left:57px;\" src=\"/192/de/static/_content/46-title-1.png\">\n        <img class=\"halfScale 46-sub\" style=\"top:188px; left:57px;\" src=\"/192/de/static/_content/46-sub-1.png\">\n        <img class=\"halfScale 46-title\" style=\"top:423px; left:57px;\" src=\"/192/de/static/_content/46-title-2.png\">\n        <img class=\"halfScale 46-sub\" style=\"top:483px; left:57px;\" src=\"/192/de/static/_content/46-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"46-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg46Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  NORDIRLAND  www.irishfa.com  EIN NEUER VORSTANDSVORSITZENDER Der neue Vorstandsvorsitzende des Nordirischen Fußballverbands (IFA), Stephen Martin, verspricht, den nordirischen Fußball auf allen Ebenen zu fördern. Martin war im Juni als unabhängiges, nicht-exekutives Mitglied des Verwaltungsrats ernannt worden, bevor er im August einstimmig zum Vorsitzenden des IFA-Vorstands gewählt wurde. Stephen Martin, der nach einer erfolgreichen, 34 Jahre dauernden Polizeikarriere vor kurzem als stellvertretender Leiter der nordirischen Polizei zurück-  getreten ist, folgt auf Spitzenbanker Gerry Mallon, der seit 2015 als Vorstandsvorsitzender fungiert hatte. Der neue Vorsitzende ist glühender Anhänger des FC Liverpool und der nordirischen Nationalelf, die er seit Kindesbeinen unterstützt. Als Jugendlicher verfolgte er die Länderspiele Nordirlands auf der Südtribüne des Windsor Park. Besonders gut sind ihm die Partien der British Home Championship und die Heimspiele im Rahmen der Qualifikation zu den WM-Endrunden 1982 in Spanien und 1986 in Mexiko in Erinnerung geblieben:  Stephen Martin  IFA  NIGEL TILSON  „Das war ein glanzvolle Zeit für die nordirische Nationalmannschaft, die ich nie vergessen werde. Jetzt sind wir wieder ausgezeichnet aufgestellt und können auf unserem Erfolg bei der EURO 2016 aufbauen.“  REPUBLIK IRLAND  www.fai.ie  GUTE AUSSICHTEN DANK NEUER TRAINERAUSBILDUNGSSTRUKTUREN GARETH MAHER  FAI  Im August führte der Irische Fußballverband (FAI) neue Strukturen bei der Trainerausbildung für den Zeitraum 2021-25 ein. Die Reaktionen darauf waren durchweg positiv. Aufbauend auf dem Erfolg der Ausbildungsstrukturen 2017-20 besuchte eine Delegation der Abteilungen für Trainerausbildung und Spitzensport der FAI mehrere Länder, holte Feedback von Hunderten von Trainern ein und arbeitete eng mit der UEFA zusammen, um neue und umfassendere Strukturen zu entwickeln, die für alle Trainerinnen und Trainer von Nutzen sind.  46 – UEFA DIRECT • Viertes Quartal 2020  Die Vorstellung der neuen Strukturen folgte auf eine beliebte Reihe wöchentlicher Webinare mit mehr als 350 000 Teilnehmern, einen regelmäßigen digitalen Newsletter und ein beispielloses Wachstum der Social-Media-Kanäle, auf denen Inhalte zur FAI-Trainerausbildung zugänglich gemacht wurden. Nach der Lockerung der COVID-19-Beschränkungen konnten die Kurse mittlerweile wieder aufgenommen werden. Dank der neuen Ausbildungsstrukturen wissen alle Trainerinnen und Trainer nun ganz genau, wie sie die nächste Stufe ihrer Karriere erreichen können. Trainerausbildung 2021-25 – wichtigste Punkte • Umsetzung der Änderungen an der UEFA-Trainerkonvention, einschließlich formeller Trainerausbilderqualifikation, Spezialistendiplome in den Bereichen Elitejunioren und Torhüter sowie Einführung der UEFA-C-Lizenz • Jahreskalender mit allen Konferenzen zur Trainerausbildung, einschließlich Fußballfitness, Frauenfußball, Torwarttraining, Pro-Lizenz, nationaler Konferenz zur Trainerausbildung und Futsal  • Modularer Fortbildungsprozess für die Bereiche Fußballfitness und Leistungsanalyse und dadurch – im Hinblick auf die Absolvierung formaler Kurse – Erreichung eines angemessenen Kompetenzniveaus in jedem Bereich • Einführung des UEFA-Breitenfußballleiter-Zertifikats als anerkannte Elitetrainer-Qualifikation und damit Möglichkeit zur Erlangung einer UEFAQualifikation für Breitenfußballtrainer • Neue optionale Workshops, wie etwa der kostenlose Online-Workshop „One Good Coach“ (Der gute Trainer) und die Online-Präsentation „Referee Intro“ (Einführung ins Schiedsrichterwesen) mit Videos zur Schärfung des Verständnisses der Trainer für die Spielregeln Niall O’Regan, Leiter Trainerausbildung bei der FAI, sagte: „In den letzten 24 Monaten haben wir die Trainerausbildungsstrukturen 2017-20 auf Herz und Nieren geprüft. Es war schön, zu sehen, wie erfolgreich sich die bisherigen Strukturen weiterentwickelt haben. Die neuen Strukturen 2021-25 fußen auf diesem Erfolg."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 47-title\" style=\"top:152px; left:71px;\" src=\"/192/de/static/_content/47-title-1.png\">\n        <img class=\"halfScale 47-sub\" style=\"top:211px; left:71px;\" src=\"/192/de/static/_content/47-sub-1.png\">\n        <img class=\"halfScale 47-title\" style=\"top:529px; left:71px;\" src=\"/192/de/static/_content/47-title-2.png\">\n        <img class=\"halfScale 47-sub\" style=\"top:589px; left:71px;\" src=\"/192/de/static/_content/47-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"47-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg47Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  RUMÄNIEN  www.frf.ro  FANS VEREWIGEN SICH AUF VIRTUELLER TRIBÜNE Mirel Rădoi steht seit November 2019 an der Spitze der rumänischen Männer-Nationalmannschaft. Zuvor führte er die U21-Nationalmannschaft bei der EM in Italien und San Marino ins Halbfinale. Leider musste die A-Nationalmannschaft aufgrund der COVID-19-Pandemie fast zehn Monate auf ihre ersten offiziellen Spiele unter dem neuen Trainer warten: ein Heimspiel der UEFA Nations League 2020/21 gegen Nordirland am 4. September, gefolgt von einem Auswärtsspiel im gleichen Wettbewerb gegen Österreich am 7. September. Das Playoff-Halbfinale gegen Island im Rahmen der EM-Qualifikation, das eigentlich für den 26. März geplant war, musste verschoben werden und findet nun am 8. Oktober statt. Für den neuen Cheftrainer und seinen Stab war es alles andere als ein einfacher  Start, und auch für die Nationalmannschaft und ihre zahlreichen treuen Anhänger war es eine Geduldsprobe. Zwischen den Fans und ihrer Nationalmannschaft besteht eine besondere Verbundenheit: Das haben die über 25 000 Kinder bewiesen, die ihre Lieblinge beim EM-2020-Qualifikationsspiel gegen Norwegen anfeuerten, das im Oktober 2019 unter Ausschluss der Öffentlichkeit gespielt wurde. Das zeigt, dass Rumänien, auch wenn es ohne Zuschauer spielen muss, niemals ohne Fans sein wird. Um diese besondere Verbundenheit in einer Zeit aufrechtzuerhalten, in der die Pandemie die Fans daran hindert, physisch nebeneinander im Stadion zu stehen, beschloss der Rumänische Fußballverband (FRF), eine virtuelle dreifarbige Tribüne in den Landesfarben Rot, Gelb und Blau „aufzubauen“. Diese originelle dreifarbige Tribüne kann über die offizielle  FRF  PAUL ZAHARIA  FRF-Website aufgerufen werden. Klickt man sie an, öffnet sich eine Google-Weltkarte, auf der die Fans einen Fußball auf die Region oder das Land ziehen können, in dem sie leben. Gleichzeitig können sie den Spielern Nachrichten schreiben. Die Karte und die empfangenen Nachrichten begleiten die Mannschaft dann überallhin: vom Heimtrainingslager in Mogoșoaia über die Umkleidekabine in der Arena Națională, dem Bukarester Nationalstadium, bis hin zu den Tribünen in den Heimstadien, in denen Rumänien während der aktuellen Kampagne der UEFA Nations League spielen wird, d.h. dem Nationalstadium und dem Ilie-Oană-Stadion in Ploiești.  RUSSLAND  www.rfs.ru  TSCHERTANOWO MOSKAU SPIELT IN DER UEFA YOUTH LEAGUE EKATERINA GRISCHENKOWA  Das Exekutivkomitee des Russischen Fußballverbands (RFS) hat beschlossen, die erste Saison der Juniorenfußballliga am 9. Juni vorzeitig zu beenden. Sieger des durch die COVID-19-Pandemie unterbrochenen Wettbewerbs wurde Tschertanowo Moskau. Der Verein darf damit in dieser Saison in der UEFA Youth League spielen. Die Juniorenfußballliga ist ein Projekt, in dessen Rahmen Russland seinen Wettbewerbsmodus auf Juniorenstufe reformieren will, und stellt eine neue Lösung dar, den Nachwuchs auf die A-Stufe vorzubereiten. In der Liga kommen die besten russischen Juniorenspieler zusammen und werden so bei ihrer Entwicklung im Junioren- und später im Profifußball unterstützt. Darüber hinaus dient die Liga als Qualifikationswett-  bewerb für die UEFA Youth League. In der ersten Saison spielten Mannschaften aus zwölf Akademien in der Liga, wobei hauptsächlich Spieler des Jahrgangs 2002 beteiligt waren. Wer in der Liga spielen durfte, entschieden die Experten des RFS anhand einer konsolidierten Bewertung der Fußballschulen. Dabei wurden die bei den Endrunden der russischen Juniorenmeisterschaften erzielten Ergebnisse sowie die Einsätze in den russischen Nationalmannschaften berücksichtigt. An der Juniorenfußballliga nahmen Mannschaften aus verschiedenen Regionen Russlands teil: Spartak Moskau, ZSKA Moskau, Lokomotive Moskau, Dynamo Moskau, Tschertanowo Moskau, Strogino Moskau, Zenit St. Petersburg, SShOR Zenit St. Petersburg, FK Krasnodar, Rubin Kasan,  Master Saturn aus der Region Moskau sowie die Konoplew-Fußballakademie aus der Region Samara kämpften erstmals um den Titel. Die erste Saison begann am 2. August 2019, endete aber aufgrund der Ausbreitung von COVID-19 in Russland am 15. März vorzeitig nach 15 Spieltagen. Tschertanowo führte zu jenem Zeitpunkt die Tabelle an und wurde zum Sieger erklärt. Mit 13 Siegen und zwei Unentschieden kam der Verein auf 41 Punkte. Zweiter wurde Dynamo Moskau, den dritten Platz erreichte FK Krasnodar. Alexander Djukow, Präsident des RFS, zeigte sich zufrieden mit den Ergebnissen der ersten Saison der Juniorenfußballliga, in der fast 400 Nachwuchsspieler an den 90 ausgetragenen Spielen teilnahmen. UEFA DIRECT • Viertes Quartal 2020 – 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-title\" style=\"top:152px; left:57px;\" src=\"/192/de/static/_content/48-title-1.png\">\n        <img class=\"halfScale 48-sub\" style=\"top:211px; left:57px;\" src=\"/192/de/static/_content/48-sub-1.png\">\n        <img class=\"halfScale 48-title\" style=\"top:482px; left:57px;\" src=\"/192/de/static/_content/48-title-2.png\">\n        <img class=\"halfScale 48-sub\" style=\"top:543px; left:57px;\" src=\"/192/de/static/_content/48-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"48-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  SCHWEDEN  www.svenskfotboll.se  JUNIORINNEN VOM REYMERSHOLMS IK FÜHLEN SICH IN SCHWARZ WOHL ANDREAS NILSSON  Dass sich alle zugehörig fühlen, dass Fußball wirklich allen offensteht – das lässt sich auf verschiedene Arten bewerkstelligen. Warum also nicht zum Beispiel die Farben der Teambekleidung anpassen? Reymersholms IK aus Stockholm wurde 1899 gegründet und spielt seit eh und je in denselben Farben: grüne Trikots, weiße Hosen, grüne Stutzen. Doch in diesem Frühjahr sind die U14-Juniorinnen des Klubs beim Vorstand vorstellig geworden: Er solle ihnen doch bitte erlauben, mit schwarzen statt weißen Hosen zu spielen. Angesichts von Pubertät und Monatsblutung fühlten sich viele Mädchen in den  dünnen weißen Hosen unwohl; sie hatten Angst, Flecken könnten sichtbar werden. Einige zogen zusätzlich eine Aufwärmoder Radlerhose an, andere wiederum lehnten es rundweg ab, während ihrer Periode aufzulaufen. „Für mich ist es wichtig, dass sich die Mädchen beim Fußballspielen wohlfühlen. Als Erwachsene haben wir die Verantwortung, den Kindern zu zeigen, dass wir ihre Anliegen ernst nehmen und vernünftige Entscheidungen treffen“, sagte Trainerin Line Trondsen Hetteberg. Getreu des Vereinsmottos „Für so viele wie möglich, für so lange wie möglich“ war der Vorstand von Reymersholms IK der gleichen Meinung.  „Sie trugen uns ein Problem vor und hatten eine einfache Lösung dafür. Die Entscheidung fiel uns nicht schwer, nach drei Minuten war sich der Vorstand einig“, verriet Hans Förnestig, Vorstandsvorsitzender. Bereits im Sommer standen für alle Juniorinnenteams von Reymersholms schwarze Shorts zur Verfügung. Endlich konnten sie sich wieder voll und ganz auf Fußball konzentrieren. „Es freut mich sehr, dass sich der Vorstand bei den Spielkleidungsfarben flexibel gezeigt hat. Das verdeutlicht, dass unser Klub mit der Zeit gehen kann“, sagte Line Trondsen Hetteberg.  SCHWEIZ  EX-NATIONALTRAINER PAUL WOLFISBERG GESTORBEN  SFV-ASF  www.football.ch  PIERRE BENOIT  Neun Monate nach dem Tod des ehemaligen Nationalcoachs Jakob „Köbi“ Kuhn ist auch einer seiner Vorgänger im Amt verstorben. Paul Wolfisberg erlag Ende August in seiner Wohngemeinde Horw im Alter von 87 Jahren einem Schwächeanfall. Der Luzerner, der als Spieler im Jahr 1960 mit dem FC Luzern den Cup gewann, führte den FCL 1979 als Trainer in die Nationalliga A und coachte später (von 1981-85 und 1989) die Schweizer Nationalmannschaft. Obwohl der Innerschweizer keine großen Erfolge feiern konnte und sich nie für eine EURO oder eine WM-Endrunde zu qualifizieren vermochte, stieg während seiner Amtszeit das zuvor angeschlagene Image des SFV-Aushängeschilds wieder. In 52 Länderspielen stand „der Wolf“ an der Seitenlinie – für die Schweiz gab es in dieser Zeitspanne 17 Siege (bei 20 Unentschieden und 15 Niederlagen). 48 – UEFA DIRECT • Viertes Quartal 2020  Trotz der relativ bescheidenen Ausbeute genoss der Fachmann in der Schweiz hohes Ansehen und große Beliebtheit bei Spielern und Fans. Dank der neu entfachten Euphorie zog die Schweiz auch wieder die Fans an und die „Freunde der Schweizer Fussball-Nationalmannschaften“ verzeichneten während der Ära Wolfisberg einen massiven Mitgliederzuwachs. Zu einem Testspiel gegen Brasilien kamen 1983 in Basel 60 000 Zuschauer in den St. Jakob.Park, zwei Jahre zuvor sahen 40 000 Fans den Heimsieg in Basel gegen England, in der Qualifikation zur WM 1986 in Mexiko füllten 38 000 beziehungsweise 51 000 Zuschauer das Berner Wankdorf bei den Spielen gegen Dänemark und die Sowjetunion. SFV-Präsident Dominique Blanc und Andy Egli, unter Wolfisberg Abwehrspieler im Nationalteam, erinnern sich mit großem Respekt an den verstorbenen Ex-Nationalcoach. Dominique Blanc erklärte: „Paul  Wolfisberg hat die Schweizer FußballNationalmannschaft in den 1980er-Jahren nach einer langen Durststrecke zurück in die Erfolgsspur gebracht. Bodenständig, authentisch und zugleich hochprofessionell hat er sich in die Herzen der Schweizerinnen und Schweizer gespielt. Der Schweizer Fußball trauert um einen Großen.“ Andy Egli sagte: „Für mich kommt diese Hiobsbotschaft sehr überraschend, denn zwei Tage vorher saßen wir noch an einem Geburtstagsfest zusammen. Paul Wolfisberg war eine große Persönlichkeit, hatte einen guten Führungsstil und ließ den Spielern, wie später auch Köbi Kuhn, viele Freiheiten. Er war ebenso kompetent wie witzig und vertraute den jungen Spielern, davon profitierte auch ich. Er verstand es, uns viel Selbstvertrauen einzuimpfen – sein Tod ist für den Schweizer Fußball ein herber Verlust. “"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 49-title\" style=\"top:152px; left:71px;\" src=\"/192/de/static/_content/49-title-1.png\">\n        <img class=\"halfScale 49-sub\" style=\"top:211px; left:71px;\" src=\"/192/de/static/_content/49-sub-1.png\">\n        <img class=\"halfScale 49-title\" style=\"top:525px; left:71px;\" src=\"/192/de/static/_content/49-title-2.png\">\n        <img class=\"halfScale 49-sub\" style=\"top:589px; left:71px;\" src=\"/192/de/static/_content/49-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.staggerFromTo(cOf(\"49-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"49-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg49Anim.stop();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  SLOWAKEI  www.futbalsfz.sk  RUNDE GEBURTSTAGE UND TRAUER UM VERSTORBENE PETER ŠURIN  Während der COVID-19-Pandemie, als immer weniger Spiele ausgetragen wurden und die Öffentlichkeit gegen einen unsichtbaren Feind kämpfte, feierten zwei prominente Mitglieder der slowakischen Fußballfamilie ihren 70. Geburtstag. Als Erster an der Reihe war im März der Kapitän der Europameistermannschaft von 1976, Anton Ondruš. Der Libero der damaligen Tschechoslowakei galt als „Beckenbauer des Ostens“, war kopfballstark und hatte einen siebten Sinn für das optimale Stellungsspiel. Er war einer der Schlüsselakteure der siegreichen Mannschaft von 1976 und belegte in jenem Jahr bei der Wahl zum Weltfußballer des Jahres den sechsten Platz, das beste Ergebnis, das je ein slowakischer Spieler erzielt hat. Nachdem er seine Spielerkarriere beendet hatte, ließ  er sich im französischen Thonon-les-Bains nieder. Er blieb aber dem slowakischen Fußball als Trainer der Nationalmannschaft und von Slovan Bratislava – wo er auch ein Jahr lang als Vereinspräsident fungierte – verbunden. Anton Ondruš gehört der Ruhmeshalle des slowakischen Fußballs an. Vor der EURO 2016 zählte ihn die UEFA zu den 50 besten Spielern in der Geschichte der Europameisterschaft. Im August war Marián Masný an der Reihe, Ondruš’ langjähriger Teamkollege sowohl im Verein wie auch in der Nationalmannschaft. Als herausragender Flügelstürmer absolvierte Masný 345 Ligaspiele und erzielte 103 Tore. Mit Slovan Bratislava, wo er elf Jahre spielte, gewann er je zwei Meistertitel und Pokalwettbewerbe. Er hat zwei EM-Medaillen: Gold von 1976, Bronze von 1980. Zudem spielte er bei der WM 1982. In 75 Länderspielen  UKRAINE		  erzielte er 18 Tore und war lange Zeit Rekordnationalspieler. Bei der bereits erwähnten Wahl zum Weltfußballer des Jahres 1976 belegte er den neunten Platz. In einem Kommentar zur EM-Endrunde 1976 schrieb Jacques Ferran, Journalist und Direktor der Zeitschrift France Football: „Im Finale sahen wir einen zukünftigen Weltstar – Masný.“ Leider bedeutet Leben auch Tod. Jüngst verlor der slowakische Fußball drei große Spielerpersönlichkeiten: Marián Čišovský (41), ehemaliger Spieler von Inter Bratislava, MŠK Žilina, Petržalka Bratislava, Politehnica Timișoara und Viktoria Pilsen, erlag einer Nervenkrankheit. Die zwei Europameister Jaroslav Pollák (73) und Pavol Biroš (67) verstarben beide nach schwerer Krankheit. Die slowakische Fußballfamilie wird sie nie vergessen. www.ffu.org.ua  VSA-AUSBILDUNG FÜR SCHIEDSRICHTER UND ZERTIFIZIERUNG VON AUSBILDERN Der Ukrainische Fußballverband (FFU) hat die zweite Phase der Ausbildung für Video-Schiedsrichterassistenten (VSA) in Angriff genommen. Nun vertiefen die Schiedsrichter die Kenntnisse, die sie in der ersten Ausbildungsphase erworben haben. Gleichzeitig will die Schiedsrichterkommission des Verbands die Zahl der zertifizierten VSA-Ausbilder erhöhen. Der VSA-Ausbildungsprozess begann im Juli, als mehrere Schulungseinheiten (Einführung, Überprüfung von Videomaterial, Analyse komplexer Spielsituationen) abgeschlossen wurden. An der zweiten Ausbildungsphase nehmen 14 Schiedsrichter teil, die ab November als VSA fungieren dürfen. In dieser zweiten Phase üben die Schiedsrichter in simulierten Spielsituationen  Volodymyr Rasner  JURI MASNITSCHENKO  und kurzen Freundschaftsspielen. Ziel ist es auch, zertifizierte einheimische Ausbilder hervorzubringen, die künftig ähnliche Ausbildungen selbstständig durchführen können. Mit Luciano Luci, dem Vorsitzenden der Schiedsrichterkommission, gibt es in der Ukraine derzeit nur einen  zertifizierten VSA-Ausbilder. „Wir haben einen FIFA-Spezialisten zur Ausbildung unserer Schiedsrichter sowie zur Zertifizierung von VSA-Ausbildern eingeladen. Nach der Ausbildung werden der Kenntnisstand und die Fähigkeiten der Schiedsrichter bewertet. Sobald sie zertifiziert sind, kann der Verband die Ausbildung von Schiedsrichtern für die Arbeit mit dem VSA-System systematisch angehen. Ausländische Experten müssen dann nicht mehr herangezogen werden“, erläuterte Luciano Luci. Darüber hinaus plant die FFU, weitere Ausrüstung und einen zweiten VSA-Transporter anzuschaffen, um die Anzahl der betreuten Spiele in der obersten ukrainischen Liga von derzeit zwei auf vier Spiele pro Spieltag auszuweiten. UEFA DIRECT • Viertes Quartal 2020 – 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 50-title\" style=\"top:152px; left:57px;\" src=\"/192/de/static/_content/50-title-1.png\">\n        <img class=\"halfScale 50-sub\" style=\"top:187px; left:57px;\" src=\"/192/de/static/_content/50-sub-1.png\">\n        <img class=\"halfScale 50-title\" style=\"top:565px; left:57px;\" src=\"/192/de/static/_content/50-title-2.png\">\n        <img class=\"halfScale 50-sub\" style=\"top:601px; left:57px;\" src=\"/192/de/static/_content/50-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:733px;left:251px;width:40px;height:12px;\">\n          <a href=\"https://www.facebook.com/FAWales/videos/308529100501208/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:733px;left:350px;width:39px;height:12px;\">\n          <a href=\"https://www.youtube.com/watch?v=FQVW4UvD-wI\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.staggerFromTo(cOf(\"50-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"50-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg50Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MITGLIEDSVERBÄNDE  UNGARN  www.en.mlsz.hu  RECHTZEITIGES MEISTERSCHAFTSENDE MÁRTON DINNYÉS  Seit dem Ausbruch der COVID19-Pandemie in Ungarn hat der Ungarische Fußballverband (MLSZ) fortlaufend auf Regierungsentscheidungen reagiert und sich für den Schutz der Teilnehmer von Fußballspielen eingesetzt. Die Begegnungen, die über die Teilnahme an den UEFA-Wettbewerben der nächsten Saison entschieden, wurden auf Mai und Juni verschoben und konnten rechtzeitig abgeschlossen werden. Als Reaktion auf die Entscheidung der Regierung vom 11. März ordnete der MLSZ an, Fußballspiele ohne Zuschauer auszutragen. Drei Tage später kündigte der Verband an, dass die Juniorenmeisterschaften ab dem 16. März unterbrochen würden. Daraufhin kam der ungarische Fußball zu einem Stillstand: Nach dem 16. März fanden in Ungarn keine Spiele mehr statt, und auch die vom MLSZ bereits organisierten Schulungen wurden ausgesetzt. Vor diesem Hintergrund hielt der MLSZ am 21. April als erster UEFA-Mitgliedsverband seine Präsidentschaftswahlen digital ab. Sándor Csányi wurde einstimmig für  weitere fünf Jahre zum Präsidenten gewählt. Im Mai konnten die Fußballer endlich wieder in Aktion treten, wenn zunächst auch nur vor leeren Zuschauerrängen. Unter strengen Auflagen wurde der Spielbetrieb in der OTP Bank Liga, im ungarischen Pokal und in der Women’s Simple League wieder aufgenommen. Ungarn war eines der ersten Länder, das wieder Fußballspiele erlaubte. Die ersten Spiele waren die Halbfinalbegegnungen des ungarischen Pokals (am 23. Mai). Vor einer begrenzten Anzahl von Zuschauern nahm die oberste Männerliga, die OTP Bank Liga, ihren Spielbetrieb am Wochenende vom 29. Mai mit dem 26. Spieltag wieder auf. Auch in der Frauenliga begann der Ball wieder zu rollen, und zwar mit dem Playoff-Finale, das darüber entscheiden sollte, welche Mannschaft Ungarn in der UEFA Women’s Champions League vertreten würde. In den Futsal-, Amateur- und Juniorenligen wurde der Spielbetrieb nach der Unterbrechung im März nicht wieder aufgenommen. In dieser Zeit mussten in den Stadien sogenannte „Sportzonen“  WALES  eingerichtet werden, die nur von Personen mit einem negativen Testergebnis betreten werden durften. Ab dem 29. Mai konnten Spiele wieder vor Fans ausgetragen werden, aber immer noch unter Einhaltung strenger Regeln und eines Abstands von 1,5 Metern zwischen den Zuschauern. Unter diesen Bedingungen fand am 3. Juni das ungarische Pokalfinale zwischen Honvéd Budapest und Mezőkövesd-Zsóry SE im neuen Nationalstadion, der Puskás Aréna, statt. Die Begrenzung der Zuschauerzahl wurde am 18. Juni aufgehoben. Gleichzeitig blieb das Testregime zum Schutz der Gesundheit von Spielern und Betreuern eine Priorität, wobei die Zuständigkeit für die entsprechenden Entscheidungen an die Vereine überging. Die OTP Bank Liga 2019/20 hielt den überarbeiteten Zeitplan ein und konnte ihre Meisterschaft am 27. Juni abschließen. Insgesamt wurden in diesem Zeitraum 543 Spieler getestet und 5 157 PCR-Tests durchgeführt. Aktive positive Fälle gab es keine, serologische (frühere) Fälle wurden sechs verzeichnet. www.faw.cymru  RYAN GIGGS: CYMRU Um nach der Fußballzwangspause dem Austausch der walisischen Nationalmannschaft mit ihren Fans neues Leben einzuhauchen, hat der Walisische Fußballverband (FAW) vor dem ersten Länderspiel im September eine exklusive Hinter-den-Kulissen-Dokuserie über die ersten beiden Jahre von Ryan Giggs als Nationaltrainer veröffentlicht. Die fünfteilige Serie umfasst Archivmaterial sowie Interviews mit Personen, die im Zentrum des Geschehens stehen, darunter Ryan Giggs, langjährige Nationalspieler und Funktionäre. Sie alle wurden von Tiny Welsh Media, dem Videoteam der FAW, begleitet. Unter dem Titel „Ryan Giggs: Cymru“ dokumentiert die Serie die Höhen und Tiefen des Trainerlebens: von Giggs’ 50 – UEFA DIRECT • Viertes Quartal 2020  Ernennung zum Nationaltrainer im Januar 2018 über die Reise der Nationalmannschaft quer durch die Welt – von China bis nach Los Angeles – bis hin zur Qualifikationskampagne für die EURO 2020. Abgerundet wird die Dokuserie mit bewegenden Bildern der Besuche des Cymru-Trainers bei Juniorenfußballvereinen und Schulen in ganz Wales. Aufgeschaltet wurde die Serie auf der Facebook-Seite und dem YouTube-Kanal der FAW. Dort erhielten die Mitglieder von „The Red Wall“, dem Fanclub der FAW, exklusiven und sofortigen Zugang. Über einen privaten Newsletter sammelte die FAW zudem Fragen der Fans, die Ryan Giggs dann in einem Gespräch mit dem FAW-Kommunikationschef, Ian Gwyn Hughes, beantwortete. Dort äußerte sich  FAW  MELISSA PALMER  der Nationaltrainer auch ganz offen über die Dokuserie an sich und seine Zeit als Cymru-Cheftrainer. Veröffentlicht wurden die Fragen und Antworten am Vorabend des seit November 2019 ersten Cymru-Länderspiels. Damit wollte man das Interesse der Fans an der Nationalelf der Männer vor der Länderspielwoche erhöhen."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "AGENDA  WETTBEWERBE  SITZUNGEN  Oktober  25.11.-1.12.2020 Frauen-Europameisterschaft: Qualifikationsspiele  1.10.2020 Europa League: Playoffs  26.11.2020 Europa League: Gruppenspiele (4. Spieltag)  7.-13.10.2020 U21-Europameisterschaft: Qualifikationsspiele  1.10.2020 in Genf Auslosung der Gruppenphase der Champions League  Dezember  2.10.2020 in Nyon Auslosung der Gruppenphase der Europa League  8.10.2020 Playoffs zur UEFA EURO 2020 9.-11.10.2020 in Barcelona Endphase der Futsal Champions League 10./11.10.2020 Nations League: 3. Spieltag 13./14.10.2020 Nations League: 4. Spieltag 20./21.10.2020 Champions League: Gruppenspiele (1. Spieltag) 21.-27.10.2020 Frauen-Europameisterschaft: Qualifikationsspiele 22.10.2020 Europa League: Gruppenspiele (1. Spieltag) 27./28.10.2020 Champions League: Gruppenspiele (2. Spieltag)  1./2.12.2020 Champions League: Gruppenspiele (5. Spieltag) 3.12.2020 Europa League: Gruppenspiele (5. Spieltag) 6.-9.12.2020 Futsal-Europameisterschaft: Gruppenspiele 8./9.12.2020 Women’s Champions League: Sechzehntelfinale (Hinspiele) 8./9.12.2020 Champions League: Gruppenspiele (6. Spieltag) 10.12.2020 Europa League: Gruppenspiele (6. Spieltag) 15./16.12.2020 Women’s Champions League: Sechzehntelfinale (Rückspiele)  29.10.2020 Europa League: Gruppenspiele (2. Spieltag)  Oktober  23.10.2020 in Nyon Auslosung der Qualifikationsspiele der U19Futsal-Europameisterschaft November 26.11.2020 Kommission für Junioren- und Amateurfußball Dezember 3.12.2020 in Nyon Auslosung der Endphase der Nations League Exekutivkomitee 7.12.2020 in Nyon Auslosung der Playoffs der FrauenEuropameisterschaft Auslosung des Qualifikationswettbewerbs der Frauen-WM 14.12.2020 in Nyon Auslosung der Achtelfinalspiele der Champions League und der Sechzehntelfinalspiele der Europa League  November 2.-11.11.2020 Futsal-WM: europäische Qualifikationsspiele (Playoffs)  MITTEILUNGEN  Futsal-Europameisterschaft: Playoffs des Qualifikationswettbewerbs  • Fernando Gomes wurde für eine weitere vierjährige Amtszeit zum Präsidenten des Portugiesischen Fußballverbands gewählt.  3./4.11.2020 Champions League: Gruppenspiele (3. Spieltag)  • Tomas Danilevičius wurde für eine weitere vierjährige Amtszeit zum Präsidenten des Litauischen Fußball­verbands gewählt.  Women’s Champions League: 1. Qualifikationsrunde 5.11.2020 Europa League: Gruppenspiele (3. Spieltag) 12.11.2020 Playoffs zur EURO 2020 12.-19.11.2020 U21-Europameisterschaft: Qualifikationsspiele 14./15.11.2020 Nations League: 5. Spieltag 17./18.11.2020 Nations League: 6. Spieltag 18./19.11.2020 Women’s Champions League: 2. Qualifikationsrunde 24./25.11.2020 Champions League: Gruppenspiele (4. Spieltag) 24.-29.11.2020 Futsal Champions League: Vorrunde  • Ari Lahti wurde für eine weitere vierjährige Amtszeit zum Präsidenten des Finnischen Fußballverbands gewählt. • Luis Rubiales wurde für eine weitere vierjährige Amtszeit zum Präsidenten des Spanischen Fußballverbands gewählt.  NACHRUF Der ehemalige Präsident des Rumänischen Fußballverbands, Mircea Pascu, ist am 16. September im Alter von 85 Jahren verstorben. Bei der UEFA war er von 1984 bis 1992 Mitglied der Kommission für Klubwettbewerbe und von 1992 bis 1998 Mitglied der Kommission für Fairplay. Zudem gehörte er dem Freundeskreis der Ehemaligen an. Am gleichen Tag wie Mircea Pascu ist auch Fino Fini (Italien), ein weiteres Mitglied des Freundeskreises der Ehemaligen, im Alter von 92 Jahren gestorben. Er war von 1976 bis 1992 Mitglied der Kommission für technische Entwicklung und von 1980 bis 1982 Mitglied der Unterkommission der Medizinischen Kommission.  Lars-Åke Lagrell, ehemaliger Präsident des Schwedischen Fußballverbands, ist am 21. September im Alter von 80 Jahren verstorben. Bei der UEFA war er von 1986 bis 1992 Mitglied der Kommission für Futsal und von 1992 bis 2000 Mitglied der Kommission für Klubwettbewerbe. Von 2000 bis 2007 war er Präsident und von 2007 bis 2011 Vizepräsident der Kommission für Nationalmannschaftswettbewerbe. Außerdem war er Vizepräsident (2009-2011) und beigezogenes Mitglied (2011-2015) der Kommission für Landesverbände. Er gehörte ebenfalls dem Freundeskreis der Ehemaligen an und erhielt 2016 den UEFA-Verdienstorden in Diamant.  UEFA DIRECT • Viertes Quartal 2020 – 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-23',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "QRRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UR7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WI9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zhdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "be29":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "clAw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f34v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gUQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1X4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mp9z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1149aeb150e191c92476.js